const en = {
lang: { fr: 'Français', en: 'English' },
  nav: {
    home: 'Home',
    publishRequest: 'Post a request',
    becomeProvider: 'Become a provider',
    afterSales: 'After-sales service',
    demos: 'Demos',
    pages: 'Pages',
    login: 'Log in',
    signup: 'Sign up',
    logout: 'Log out',
    myAccount: 'My account',
    hello: 'Hello, {{name}}',
    myPayments: 'My payments',
  },
  footer: {
    pages: 'Pages',
    home: 'Home',
    becomeProvider: 'Become a provider',
    publishRequest: 'Post a request',
    afterSales: 'After-sales service',
    login: 'Log in',
    signup: 'Sign up',
    rights: 'All rights reserved.',
    terms: 'Terms of use',
    privacy: 'Privacy policy',
    ctaTitle: 'Find a professional near you',
    ctaBody: 'Post your request in minutes and get connected with trusted local providers.',
    ctaButton: 'Post a request',
    contact: 'Contact',
    copyright: 'All rights reserved.',
  },
  home: {
    bannerTitle: 'Find trusted local professionals for all your everyday services.',
    bannerSub: 'Book quickly, pay securely, and get the job done with confidence.',
    servicesTitle: 'All available services',
    servicesSub: 'Unlock the potential of our service hub and access valuable solutions for your business growth.',
    searchPlaceholder: 'Search services...',
    groupLabel: 'Service group',
    sortLabel: 'Sort by',
    sortDefault: 'Default',
    sortNameAsc: 'Name (A-Z)',
    sortNameDesc: 'Name (Z-A)',
    sortNewest: 'Newest first',
    results: 'Results: {{count}} service',
    results_plural: 'Results: {{count}} services',
    clearFilters: 'Clear filters',
    loadingServices: 'Loading services...',
    noServices: 'No services found. Try another search or category.',
    viewAllServices: 'View all services',
    mapTitle: 'User and provider location',
    mapUser: 'User',
    mapProvider: 'Provider',
    mapYourPosition: 'Your location',
    groups: {
      all: 'All services',
      homeWorks: 'Home & works',
      outdoor: 'Outdoor & garden',
      transport: 'Transport',
      security: 'Security',
    },
    howTitle: 'How to use the platform?',
    step1Title: '1- Post a request',
    step1Text: 'Choose a category and describe your project.',
    step2Title: '2- Get a quote within 24h',
    step2Text: 'Review offers from trusted craftsmen.',
    step3Title: '3- Choose your provider',
    step3Text: 'Individual or professional according to your budget.',
    step4Title: '4- Find the right provider in a few clicks',
    step4Text: 'Book, enjoy, and share your experience.',
    trustTitle: 'Why trust Allo Alla?',
    trustP1: 'Allo Alla is a service platform connecting people who need help with their projects to qualified providers and experts.',
    trustP2: 'Find a provider for all your home renovation needs.',
    trustP3: 'Within 48 hours, you can receive offers to install a shelf, fit a kitchen, paint a wall, tile a bathroom, or maintain your garden.',
    trustP4: 'Our network of qualified professionals is carefully selected and verified by our team. You can read customer reviews and provider awards.',
    trustP5: 'Our services include quality guarantees to support you in case of unexpected issues, with clear terms and dedicated assistance throughout your project.',
    providerTitle: 'Want to become a provider?',
    providerP1: 'Are you a trade professional? Sign up online now to access qualified job offers published by our partners.',
    providerP2: 'Or maybe you are an individual who prefers to do small jobs in your spare time? Become an Allo Alla craftsman and receive requests directly on your phone.',
    providerP3: 'In all cases, our service is 100% free for providers.',
    providerLi1: 'Find jobs near you',
    providerLi2: 'Submit your quote',
    providerLi3: 'Get paid',
    providerP4: 'The Allo Alla team verifies every registered craftsman through identity, business information (for professionals), qualification certificates, and insurance documents.',
    becomeArtisan: 'Become a craftsman',
  },
  payment: {
    title: 'Payment',
    canceled: 'Payment canceled. You can try again below.',
    amountToPay: 'Amount to pay',
    card: 'Bank card',
    onSite: 'On site',
    cardTitle: 'Card payment',
    onSiteTitle: 'On-site payment',
    cardSub: 'Enter your details to complete the payment.',
    onSiteSub: 'Confirm that you will pay this amount in cash to the provider.',
    commentLabel: 'Comment (optional)',
    commentPlaceholder: 'E.g.: I will pay at the end of the job',
    confirm: 'Confirm {{amount}}',
    saving: 'Saving…',
    back: 'Back',
    invalidAmount: 'Invalid amount',
    loadingStripe: 'Loading Stripe configuration…',
    backendError: 'Cannot reach the backend (port 5001). Restart the server.',
    stripeKeyMissing: 'Missing Stripe publishable key in backend/.env (STRIPE_PUBLISHABLE_KEY=pk_test_...).',
    payStripe: 'Pay {{amount}} (Stripe page)',
    redirecting: 'Redirecting…',
    defaultDescription: 'Service',
    summaryTitle: 'Summary',
    service: 'Service',
    subtotal: 'Subtotal',
    vatIncluded: 'VAT (included)',
    total: 'Total',
    stripeRedirectError: 'Stripe redirect failed.',
    stripeError: 'Stripe error.',
    onSiteSaveError: 'Could not save on-site payment.',
    saveError: 'Error while saving.',
    paymentDescription: 'Nioland payment',
    onSiteDescription: 'On-site payment',
    serviceReminderBanner: 'You are paying for: {{desc}}',
    receiptNote: 'A receipt will be sent to {{email}} after payment.',
    trustEncrypted: 'Encrypted',
    trustStripe: 'Secured by Stripe',
    trustReceipt: 'Receipt by email',
    onSiteWarning: 'Note: On-site payments must be confirmed by your provider before the service begins.',
    allFeesNote: 'incl. all fees',
    cardForm: {
      cardholderName: 'Name on card',
      cardholderPlaceholder: 'John Doe',
      billingEmail: 'Billing email',
      billingEmailPlaceholder: 'you@example.com',
      cardNumber: 'Card number',
      expiry: 'Expiry date',
      cvc: 'Security code (CVC)',
      pay: 'Pay {{amount}}',
      paying: 'Processing payment…',
      secureNote: 'Encrypted payment via Stripe · We do not store your card details',
      stripeNotLoaded: 'Stripe is not loaded yet. Please try again shortly.',
      amountInvalid: 'Enter a valid amount in the summary.',
      nameRequired: 'Enter the name on the card',
      emailRequired: 'Enter the billing email',
      formUnavailable: 'Card form unavailable',
      prepareFailed: 'Could not prepare card payment.',
      pending: 'Payment pending confirmation.',
      error: 'Card payment error.',
      declined: 'Payment declined.',
    },
    stripeErrors: {
      cardNumberIncomplete: 'Your card number is incomplete.',
      expiryIncomplete: "Your card's expiration date is incomplete.",
      cvcIncomplete: "Your card's security code is incomplete.",
      cardNumberInvalid: 'Your card number is invalid.',
      expiryInvalid: "Your card's expiration date is invalid.",
      cvcInvalid: "Your card's security code is invalid.",
      cardExpired: 'Your card has expired.',
      cardDeclined: 'Your card was declined.',
      processingError: 'An error occurred while processing your card. Try again in a little bit.',
    },
  },
  paymentReturn: {
    pageTitle: 'Payment confirmation',
    verifying: 'Verifying your payment…',
    verifyError: 'Could not verify payment.',
    statusCompleted: 'Payment confirmed',
    statusPending: 'Payment pending',
    statusFailed: 'Payment failed',
    statusExpired: 'Payment expired',
    statusOnSite: 'On-site payment',
    successHeading: 'Payment successful!',
    successNote: 'A receipt has been sent to your email.',
    failedHeading: 'Payment failed',
    failedNote: 'Your payment could not be processed. Please try again or contact support.',
    pendingHeading: 'Confirming your payment…',
    pendingNote: 'This page refreshes automatically.',
    autoRefresh: 'This page refreshes automatically every few seconds.',
    onSiteNote: 'Your on-site payment has been registered. The provider will confirm receipt before the service begins.',
    onSiteRegistered: 'On-site payment registered',
    next1: 'You will receive a confirmation email shortly.',
    next2: 'A provider will be assigned to your request.',
    next3: 'You can track your request from your profile.',
    retryPayment: 'Try again',
    contactSupport: 'Contact support',
    backToHome: 'Back to home',
    goToProfile: 'My profile',
    nextStepsTitle: 'What happens next',
  },
  wizard: {
    step: 'Step {{n}}',
    step2Title: 'Project title',
    step2Heading: 'Give your project a title',
    step2Label: 'Project title',
    step2Placeholder: 'e.g. Bathroom renovation — Tunis',
    step2Hint: 'A clear title helps professionals understand your request quickly.',
    step2Next: 'Next',
    step2Back: 'Back',
    step3Title: 'Request details',
    step4Title: 'Service details',
    step5Title: 'Photos and documents',
    step5Heading: 'Add photos or documents',
    step5Description: 'Photos help providers better understand your needs and prepare an accurate quote.',
    step5Dropzone: 'Click to add files',
    step5Hint: 'Images or PDF — up to 4 files, 7 MB each',
    step5FilesSelected: '{{count}} file selected',
    step5FilesSelected_plural: '{{count}} files selected',
    step5MaxFiles: 'You can add up to 4 files.',
    step5FileTooLarge: '"{{name}}" exceeds the 7 MB size limit.',
    step6Title: 'Type of service',
    step6Heading: 'What type of service do you need?',
    step6Description: 'Specify whether you want the provider to prepare a plan before carrying out the work.',
    step6Question: 'Choose an option',
    step6PlanAndExecution: 'Planning + execution',
    step6ExecutionOnly: 'Execution only',
    step7Title: 'Service location',
    step7Heading: 'Where will the service take place?',
    step7Description: 'Enter the service area to find providers near you.',
    step7Region: 'Region',
    step7SelectRegion: 'Select a region',
    step7City: 'City',
    step7SelectCity: 'Select a city',
    step7ExactAddress: 'Exact address (optional)',
    step7AddressPlaceholder: 'Street, number, landmark…',
    step7PrivacyNote: 'Your exact address is only shared with the provider you choose.',
    step8Title: 'Timing',
    step8Heading: 'When would you like the service to take place?',
    step8Description: 'Choose an exact date or a deadline.',
    step8DeadlineLabel: 'Preferred deadline',
    step8ExactDate: 'On an exact date',
    step8ExactDateWithDate: 'On {{date}}{{time}}',
    step8ChooseDate: 'Date',
    step8ChooseTime: 'Time (optional)',
    step8TimePrefix: ' at {{time}}',
    step8BeforeDateWithDate: 'Before {{date}}{{time}}',
    step8BeforeDatePlain: 'Before a deadline',
    step8DeadlineDate: 'Deadline date',
    step8DeadlineTime: 'Deadline time (optional)',
    step9Title: 'Budget and providers',
    step9Heading: 'What is your budget?',
    step9BudgetQuestion: 'Budget range',
    step9SelectRange: 'Select a range',
    step9CustomBudget: 'Or enter your budget (TND)',
    step9Average: 'Average observed price:',
    step9SimilarTitle: 'Similar providers',
    step9SimilarDesc: 'Here are {{subService}} providers ({{parent}}) available{{zone}}.',
    step9SimilarZone: ' in your area ({{zone}})',
    step9LoadingProviders: 'Loading providers…',
    step9NoProviders: 'No providers found yet.',
    step9ViewAllProviders: 'View all providers',
    step9ProviderFallback: 'Provider',
    step9OnQuote: 'On quote',
    step9ZoneUnknown: 'Area not specified',
    step9ReviewsCount: '{{count}} review',
    step9ReviewsCount_plural: '{{count}} reviews',
    step9InterventionFor: 'Provides: {{subService}}',
    step9YearsExperience: '{{years}} years of experience',
    step9VerifiedProvider: 'Verified provider',
    step9ViewProfile: 'View profile',
    step9ProvidersError: 'Unable to load providers.',
    step10Title: 'Summary',
    step10Heading: 'Summary of your request',
    step10Description: 'Review your request details before submitting.',
    step10ImageAlt: 'Service illustration',
    step10ViewDetails: 'View details',
    step10DefaultTitle: 'Service request',
    step10ExtraLabel: 'Additional details (optional)',
    step11Title: 'Your contact details',
    step11Heading: 'How can we reach you?',
    step11Description: 'Leave your email address so providers can contact you.',
    step11EmailLabel: 'Email address',
    step11EmailPlaceholder: 'e.g. you@example.com',
    step11PrivacyTitle: 'Your data visibility',
    step11PrivacyPrivate: 'Keep my information private',
    step11PrivacyShare: 'Share my information with the chosen provider',
    step11PrivacyNote: 'You can change this choice at any time from your profile.',
    step11SaveError: 'Unable to save your request.',
    step11SubmitError: 'An error occurred while submitting.',
    step11Previous: 'Previous',
    step11Confirm: 'Confirm and send',
    step11Submitting: 'Submitting…',
    step12Title: 'Confirmation',
    step12Heading: 'Your request has been submitted!',
    step12Description: 'Here is a summary of your request and the next steps.',
    step12Confirmed: 'Request confirmed',
    step12EmailSent: 'A confirmation email has been sent to {{email}}.',
    step12EmailFallback: 'your email address',
    step12EmailFailed: 'The confirmation email could not be sent.{{error}}',
    step12SpamNote: 'If you do not receive the email, please check your spam folder.',
    step12NextSteps: 'Next steps',
    step12Next1: 'Review your confirmation email and keep your reference number.',
    step12Next2: 'A provider will contact you to schedule the service.',
    step12Next3: 'You can track your request from your profile at any time.',
    step12Next4: 'Complete your payment to confirm the booking.',
    step12PaymentDescription: '{{parent}} — {{subService}}{{title}}',
    step12Finish: 'Finish',
    payNow: 'Pay now',
    payNowDialogTitle: 'Confirm payment',
    payNowDialogAmount: 'Amount to pay',
    payNowReminder1: 'You will be redirected to the secure payment page.',
    payNowReminder2: 'You will receive a receipt by email after payment.',
    payNowReminder3: 'Payment confirms and secures your service booking.',
    payNowCancel: 'Cancel',
    payNowConfirm: 'Confirm & Pay',
    payInfoBanner: 'Securing your payment confirms your booking — a confirmation email will be sent after payment.',
  },
  common: {
    back: 'Back',
    backToHome: 'Back to home',
    myProfile: 'My profile',
    reference: 'Reference',
    service: 'Service',
    subService: 'Sub-service',
    changeService: 'Change service',
    start: 'Get started',
    next: 'Next',
    loading: 'Loading...',
    retry: 'Retry',
    dismiss: 'Dismiss',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    save: 'Save',
    remove: 'Remove',
    fileSizeMb: '{{size}} MB',
    fileSizeKb: '{{size}} KB',
    mapError: 'Unable to load the map.',
    mapRefresh: 'Try refreshing the page.',
    mapLoading: 'Loading map…',
    noLocationData: 'No location data available.',
    providersMustSetLocation: 'Providers must set their location in their profile.',
    viewServices: 'View services',
    yourService: 'Your service',
  },
  subService: {
    pageTitle: '{{name}} — Service details',
    intro: 'Discover our {{parent}} professionals ready to help you with this service.',
    benefit1: 'Verified and rated professionals',
    benefit2: 'Quality guaranteed or money back',
    benefit3: 'Fast response within 24 hours',
  },
  auth: {
    loginTitle: 'Sign in to your account',
    noAccount: 'Don\'t have an account yet?',
    signupLink: 'Sign up',
    signinLink: 'Sign in',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email',
    emailTaken: 'This email is already registered',
    emailAvailable: 'Email available',
    emailChecking: 'Checking email...',
    password: 'Password',
    passwordPlaceholder: 'At least 8 characters',
    passwordRequired: 'Password is required',
    pwdLower: 'At least one lowercase letter',
    pwdUpper: 'At least one uppercase letter',
    pwdDigit: 'At least one digit',
    pwdLength: 'At least 8 characters',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Sign in to your account',
    loggingIn: 'Signing in...',
    loginSuccess: 'Login successful! Redirecting...',
    loginFailed: 'Login failed',
    loginFailedBody: 'Invalid email or password. Please try again.',
    orLoginWith: 'or sign in with',
    googleLogin: 'Sign in with Google',
    pageTitle: 'Login',
    forgotTitle: 'Forgot password',
    forgotHeading: 'Forgot your password?',
    forgotSub: 'Shouldn\'t be here?',
    sendReset: 'Send reset link',
    resetSent: 'A reset link has been sent to your email.',
    resetTitle: 'Reset password',
    resetHeading: 'Reset password',
    confirmPassword: 'Confirm password',
    resetButton: 'Reset',
    resetSubmitting: 'Resetting...',
    resetSuccess: 'Your password has been reset. You can now log in.',
    resetFailed: 'Unable to reset your password.',
    resetInvalidLink: 'This reset link is invalid or has expired.',
    resetDevLink: 'Email not sent — use this link (dev):',
    forgotSubmitting: 'Sending...',
    forgotError: 'Unable to send the reset email.',
    signupTitle: 'Sign up',
    signupHeading: 'Create your account',
    signupSub: 'Already have an account?',
    signupButton: 'Sign up',
    signupGoogle: 'Sign up with Google',
    signupSubmitting: 'Registering...',
    signupButtonFull: 'Sign up to your account',
    orSignupWith: 'or sign up with',
    civility: 'Title',
    selectCivility: 'Select title',
    lastName: 'Last name',
    lastNamePlaceholder: 'Enter your last name',
    firstName: 'First name',
    firstNamePlaceholder: 'Enter your first name',
    phone: 'Phone',
    phonePlaceholder: 'Enter your phone number',
    fixe: 'Landline',
    fixePlaceholder: 'Enter your landline number',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Re-enter your password',
    role: 'Role',
    selectRole: 'Select a role',
    user: 'User',
    client: 'Client',
    provider: 'Provider',
    providerType: 'Provider type',
    company: 'Company',
    autoEntrepreneur: 'Self-employed',
    individual: 'Individual',
    providerTypeHint: 'Choose whether you are registering as a company or individual.',
    service: 'Service',
    selectService: 'Select a service',
    subService: 'Sub-service',
    selectSubService: 'Select a sub-service',
    mainService: 'Main service',
    serviceN: 'Service {{n}}',
    mainSector: 'Main sector',
    sectorN: 'Sector {{n}}',
    sector: 'Business sector',
    selectSector: 'Select a sector',
    subSector: 'Sub-sector',
    selectSubSector: 'Select a sub-sector',
    remove: 'Remove',
    add: '+ ADD',
    numCIN: 'ID card number',
    cinPhoto: 'ID card photo (AI verification)',
    cinHint: 'Upload a clear photo of your ID card for automatic verification.',
    docsAuto: 'Verification documents (self-employed)',
    docsCompany: 'Verification documents (company)',
    docsHint: 'Upload the necessary documents to verify your identity (ID, diplomas, certificates…).',
    docsCompanyHint: 'Upload the necessary documents to verify this is a company (registry extract, articles, certificate…).',
    filesSelected: '{{count}} file(s): {{names}}',
    creationYear: 'Year of creation',
    siret: 'Registration number (SIRET)',
    siretPlaceholder: 'Enter your SIRET number',
    vatNumber: 'VAT number',
    vatPlaceholder: 'Enter your VAT number',
    region: 'Region',
    selectRegion: 'Select a region',
    city: 'City',
    selectCity: 'Select a city',
    address: 'Address',
    addressPlaceholder: 'Enter your address',
    socialNetworks: 'Social networks (optional)',
    website: 'Website',
    cinPlaceholder: 'E.g.: 12345678',
    creationYearPlaceholder: 'E.g.: 2015',
  
    errors: {
      lastNameRequired: 'Last name is required',
      firstNameRequired: 'First name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email',
      phoneRequired: 'Phone is required',
      phoneDigits: 'Phone must contain 8 digits',
      fixeRequired: 'Landline is required',
      fixeDigits: 'Landline must contain 8 digits',
      passwordRequired: 'Password is required',
      confirmPasswordRequired: 'Confirm password is required',
      passwordMismatch: 'Passwords do not match',
      roleRequired: 'Role is required',
      regionRequired: 'Region is required',
      cityRequired: 'City is required',
      addressRequired: 'Address is required',
      serviceRequired: 'Please select at least one service or business sector',
      subServiceRequired: 'Please select a sub-service for "{{sect}}" (row {{line}}).',
      selectService: 'Please select at least one service.',
      passwordMismatch2: 'Passwords do not match',
      registrationFailed: 'Registration failed. Please try again.',
      serverConnectionError: 'Cannot connect to server. Make sure the backend server is running on port 5001.',
      registrationSuccessProvider: 'Registration successful. You can now log in with your credentials.',
      registrationSuccessClient: 'Registration successful.',
    },
  },
  userRequest: {
    pageTitle: 'Post a request',
    pageSubtitle: 'Select the services you need and submit your request. We will match you with the right providers.',
    loadError: 'Failed to load services. Please try again later.',
    selectOneService: 'Please select at least one service.',
    enterEmail: 'Please enter your email address.',
    availableServices: 'Available services',
    selectHint: 'Click on a service to select it. You can choose multiple services.',
    selectedTitle: 'Selected services',
    submitSuccess: 'Request submitted successfully! Redirecting...',
    submitError: 'Failed to submit request.',
    yourEmail: 'Your email',
    yourName: 'Your name (optional)',
    yourPhone: 'Your phone (optional)',
    notes: 'Additional notes (optional)',
    notesPlaceholder: 'Any details about your request...',
    submit: 'Submit request',
    submitting: 'Submitting...',
  },
  postRequest: {
    heading: 'Become a provider',
    subheading: 'Provide your service information.',
    contacting: 'Contacting:',
    theProvider: 'the provider',
    about: 'About',
    aboutPlaceholder: 'Describe your need: context, expectations, important details...',
    service: 'Service',
    selectService: 'Select a service',
    loadingServices: 'Loading services...',
    subService: 'Sub-service',
    selectSubService: 'Select a sub-service',
    availability: 'Availability',
    day: 'Day',
    available: 'Available',
    from: 'From',
    to: 'To',
    scheduleHint: 'Check "Available" and set hours for each day.',
    scheduleNotes: 'Schedule notes',
    scheduleNotesPlaceholder: 'E.g.: By appointment on weekends, variable availability...',
    interventionRegion: 'Service area - Region',
    selectRegion: 'Select a region',
    interventionCity: 'Service area - City',
    selectCity: 'Select a city',
    experience: 'Experience',
    yearsExp: 'Years of experience',
    choose: 'Choose',
    projectsCompleted: 'Projects completed',
    projectsPlaceholder: 'E.g.: 120',
    previousCompanies: 'Previous companies (optional)',
    previousCompaniesPlaceholder: 'E.g.: Company A, Company B...',
    pricing: 'Pricing',
    hourlyPrice: 'Hourly rate',
    hourlyPricePlaceholder: 'E.g.: 30 TND/h',
    dailyPrice: 'Daily rate',
    dailyPricePlaceholder: 'E.g.: 100 TND/day',
    customQuote: 'Custom quote',
    customQuotePlaceholder: 'Custom quote terms...',
    portfolio: 'Portfolio',
    photos: 'Before/after photos (links or description)',
    photosPlaceholder: 'Paste links or describe photos...',
    photosCount: '{{count}} photo(s) selected',
    projectsPortfolio: 'Completed projects (portfolio)',
    projectsPortfolioPlaceholder: 'List of completed projects...',
    projectsCount: '{{count}} project file(s) selected',
    videos: 'Videos (optional)',
    videosPlaceholder: 'Video links (YouTube, Drive, etc.)',
    videosCount: '{{count}} video(s) selected',
    clientCommitments: 'Client commitments',
    clientCommitmentsPlaceholder: 'E.g.: responses within 24h, site access, availability for meetings...',
    paymentMethod: 'Payment method',
    paymentMethods: {
      card: 'Bank card',
      transfer: 'Bank transfer',
      cash: 'Cash',
      online: 'Online payment',
      check: 'Check',
      other: 'Other',
    },
    coverageGuarantees: 'Coverage and guarantees',
    coveragePlaceholder: 'E.g.: 12-month warranty, liability insurance, damage coverage...',
    backToServices: '← Back to services',
    submit: 'Submit request',
    submitting: 'Submitting...',
    tradeRequired: 'Please select a trade.',
    submitFailed: 'Submission failed.',
    genericError: 'An error occurred.',
    successMsg: 'Request saved. Redirecting...',
    days: {
      lun: 'Monday', mar: 'Tuesday', mer: 'Wednesday', jeu: 'Thursday',
      ven: 'Friday', sam: 'Saturday', dim: 'Sunday',
    },
    closed: 'Closed',
  },
  contactPage: {
    needSupport: 'Need support',
    title: 'Contact Us',
    desc: 'Contact us for any inquiries or support you may need. Our dedicated team is ready to assist you and provide the best solutions.',
    billingPayments: 'Billing & Payments',
    billingDesc: 'Manage your billing and payments effortlessly with our user-friendly platform. Stay on top of your financial transactions and ensure smooth and secure payment processes.',
    seePricingQuestions: 'See Pricing Questions',
    usersCollab: 'Users and Collaboration',
    usersDesc: 'Connect and collaborate with users seamlessly on our platform. Share information, assign tasks, and work together efficiently to achieve your goals.',
    allDocs: 'All Documentations',
    afterSales: 'After-sales service',
    afterSalesDesc: 'Complaints, refunds, product returns, warranty, job tracking, customer support, provider evaluation, reporting… Our support team assists you and tracks every ticket to resolution.',
    openSavTicket: 'Open a support ticket',
    contactSupport: 'Contact support',
    getInTouch: 'Get in touch',
    getInTouchDesc: 'Get in touch for personalized assistance. We\'re here to help and provide solutions tailored to your requirements.',
    plansPricing: 'Plans & Pricing',
    plansDesc: 'Choose from our flexible plans and competitive pricing options to find the best fit for your business needs and budget.',
    seePricing: 'See Pricing',
    faq: 'Frequently Asked Questions',
    faqDesc: 'Find answers to commonly asked questions about our product or service in our comprehensive FAQ section.',
    seeAllQuestions: 'See All Questions',
    ctaTitle: 'Start tracking your user analytics to boost your business',
    getStarted: 'Get Started',
    pricingPlans: 'Pricing & Plans',
    newsletterTitle: 'Subscribe to our newsletter',
    newsletterDesc: 'Join the 5000+ people using Allo Alla products.',
  },
  providerSettings: {
    pageTitle: 'Provider area',
    heading: 'Provider area',
    subheading: 'View and edit your service offering: services, pricing, coverage area, etc.',
    back: 'Back',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Service offering saved.',
    loading: 'Loading…',
    serviceTrade: 'Service / Trade',
    selectService: 'Select a service',
    sector: 'Sector',
    choose: 'Choose',
    subSector: 'Sub-sector',
    regionZone: 'Region (area)',
    cityZone: 'City (area)',
    skills: 'Skills',
    skillsPlaceholder: 'E.g.: Plumbing, Sanitary installation, Repairs…',
    addSkill: 'Add',
    removeSkill: 'Remove',
    experience: 'Experience',
    qualifications: 'Qualifications',
    description: 'Description',
    pricing: 'Pricing',
    zoneDetail: 'Service area (details)',
    zonePlaceholder: 'Radius, covered areas, conditions…',
    schedule: 'Availability (schedule)',
    prestationInfo: 'Service offering information',
    prestationNote: 'For your identity and contact details, use the',
    profile: 'Profile',
    rows: {
      trade: 'Trade',
      sector: 'Sector',
      subSector: 'Sub-sector',
      skills: 'Skills',
      experience: 'Experience',
      qualifications: 'Qualifications',
      description: 'Description',
      zone: 'Service area',
      pricing: 'Pricing',
      schedule: 'Availability',
    },
  },
  admin: {
    pageTitle: 'Admin Dashboard',
    heading: 'Admin Dashboard',
    subheading: 'Platform management (users, requests, categories, stats).',
    backToProfile: 'Back to profile',
    loading: 'Loading...',
    errorLoading: 'Loading error.',
    savLoadFailed: 'Support loading failed.',
    paymentsLoadFailed: 'Payments loading failed.',
    ticketUpdated: 'Ticket updated.',
    ticketUpdateFailed: 'Support update failed.',
    replyFailed: 'Message sending failed.',
    deleteTicketConfirm: 'Delete this support ticket?',
    ticketDeleted: 'Ticket deleted.',
    deleteFailed: 'Deletion failed.',
    saveConfirm: 'Save changes?',
    accountUpdated: 'Account updated.',
    updateFailed: 'Update failed.',
    deleteUserConfirm: 'Delete {{email}}?',
    userDeleted: 'User deleted.',
    deleteFailed2: 'Deletion failed.',
    createFieldsRequired: 'Name, email and password are required to add a user.',
    userAdded: 'User added successfully.',
    userAddFailed: 'Failed to add user.',
    menu: {
      users: '1. User management',
      stats: '2. Statistics',
      requests: '3. Request management',
      categories: '4. Service Categories',
      reviews: '5. Reviews & comments',
      outreach: '6. Contact messages & blog',
      payments: '7. Payments & transactions',
      support: '8. Support & complaints',
      settings: '9. Site settings',
      system: '10. System & connections',
    },
    system: {
      title: 'System & connections',
      statusTitle: 'System status',
      refresh: 'Refresh',
      serverLabel: 'API server',
      dbLabel: 'Database',
      stripeLabel: 'Stripe (payments)',
      emailLabel: 'Email',
      up: 'Online',
      down: 'Unreachable',
      connected: 'Connected',
      disconnected: 'Disconnected',
      connecting: 'Connecting…',
      configured: 'Configured',
      notConfigured: 'Not configured',
      apiTitle: 'API server (backend)',
      apiDesc: 'Address used by the frontend to reach the backend (site content, images, logo).',
      apiLabel: 'API server URL',
      apiCurrent: 'Current URL',
      apiOverride: 'Custom',
      apiDefault: 'Default (env)',
      apiPlaceholder: 'e.g. http://localhost:5013/api',
      apiTest: 'Test',
      apiApply: 'Apply',
      apiReset: 'Reset',
      apiTestOk: 'Server connection successful',
      apiTestFail: 'Server connection failed',
      apiApplied: 'API URL applied. Reload the page to refresh all content.',
      apiResetDone: 'Override removed — default URL restored.',
      apiInvalid: 'Invalid URL (e.g. http://localhost:5013/api)',
      dbTitle: 'Database (MongoDB)',
      dbDesc: 'URI used by the backend. Saved to backend/.env and applied without a restart.',
      dbCurrent: 'Current URI',
      dbPlaceholder: 'mongodb://localhost:27017/alo-alla',
      dbTest: 'Test connection',
      dbApply: 'Apply & reconnect',
      dbTestOk: 'Connection successful',
      dbTestFail: 'Connection failed',
      dbApplyConfirm: 'Switch the MongoDB connection now? The backend will reconnect immediately.',
      dbApplied: 'Database updated and reconnected.',
    },
    config: {
      title: 'Platform configuration',
      desc: 'All backend settings (Stripe keys, email, URLs, security) — saved to backend/.env and applied immediately, no restart needed.',
      save: 'Save configuration',
      saved: 'Configuration saved and applied.',
      saveFailed: 'Save failed',
      nothingToSave: 'Nothing to save.',
      remove: 'Remove this value',
      danger: 'Sensitive',
      secretSet: 'configured (masked)',
      notSet: 'not configured',
      secretKeep: 'Leave empty to keep the current value.',
      secretEmpty: 'Not set — enter a value to configure.',
      visibleEmpty: 'Empty the field to remove the variable (default applies).',
      jwtWarning: 'Changing this secret invalidates all active sessions.',
      testEmail: 'Send a test email',
      testEmailTo: 'Test recipient',
      testEmailOk: 'Test email sent.',
      testEmailFail: 'Test email failed',
      testStripe: 'Test Stripe connection',
      testStripeOk: 'Stripe connection successful.',
      testStripeFail: 'Stripe test failed',
      stripeTitle: 'Stripe — payments',
      stripeHint: 'Keys from the Stripe Dashboard (Developers → API keys / Webhooks).',
      emailTitle: 'Email — Brevo',
      emailHint: 'Brevo keys (SMTP & API). The API key starts with xkeysib-, the SMTP key with xsmtpsib-.',
      smtpTitle: 'Email — generic SMTP (optional)',
      smtpHint: 'Only used when Brevo is not configured.',
      urlsTitle: 'URLs',
      urlsHint: 'URLs used for email links, Stripe redirects and CORS.',
      authTitle: 'Authentication',
      authHint: 'Session security — change with care.',
      fields: {
        STRIPE_SECRET_KEY: 'Stripe secret key',
        STRIPE_PUBLISHABLE_KEY: 'Stripe publishable key',
        STRIPE_WEBHOOK_SECRET: 'Stripe webhook secret',
        STRIPE_CURRENCY: 'Stripe currency',
        STRIPE_TLS_REJECT_UNAUTHORIZED: 'Stripe: ignore TLS certificate',
        BREVO_API_KEY: 'Brevo API key',
        BREVO_SMTP_KEY: 'Brevo SMTP key',
        BREVO_SMTP_LOGIN: 'Brevo SMTP login',
        BREVO_SENDER_EMAIL: 'Sender email',
        BREVO_SENDER_NAME: 'Sender name',
        EMAIL_FROM: 'Full sender (From)',
        SMTP_HOST: 'SMTP host',
        SMTP_PORT: 'SMTP port',
        SMTP_USER: 'SMTP user',
        SMTP_PASS: 'SMTP password',
        SMTP_TLS_REJECT_UNAUTHORIZED: 'SMTP: ignore TLS certificate',
        FRONTEND_URL: 'Site URL (frontend)',
        PUBLIC_BACKEND_URL: 'Public backend URL',
        CORS_ORIGINS: 'Allowed CORS origins',
        JWT_SECRET: 'JWT secret',
        AUTH_TOKEN_TTL: 'Session duration',
      },
      placeholder: {
        STRIPE_PUBLISHABLE_KEY: 'pk_test_…',
        STRIPE_CURRENCY: 'eur',
        STRIPE_TLS_REJECT_UNAUTHORIZED: 'false',
        BREVO_SMTP_LOGIN: 'abc123@smtp-brevo.com',
        BREVO_SENDER_EMAIL: 'noreply@your-domain.com',
        BREVO_SENDER_NAME: 'Alo Alla',
        EMAIL_FROM: 'Alo Alla <noreply@your-domain.com>',
        SMTP_HOST: 'smtp.example.com',
        SMTP_PORT: '587',
        SMTP_USER: 'user@example.com',
        SMTP_TLS_REJECT_UNAUTHORIZED: 'true',
        FRONTEND_URL: 'https://www.your-site.com',
        PUBLIC_BACKEND_URL: 'https://api.your-site.com',
        CORS_ORIGINS: 'https://www.your-site.com, https://your-site.com',
        AUTH_TOKEN_TTL: '12h',
      },
    },
    settings: {
      title: 'Site Settings',
      save: 'Save settings',
      saving: 'Saving...',
      saved: 'Settings saved successfully.',
      saveFailed: 'Failed to save settings.',
      loadFailed: 'Failed to load settings.',
      companyTitle: 'Company information',
      companyName: 'Company name',
      tagline: 'Tagline / description',
      contactTitle: 'Contact details',
      contactEmail: 'Email address',
      contactPhone: 'Phone number',
      contactAddress: 'Address',
      socialTitle: 'Social networks',
      footerTitle: 'Footer',
      copyright: 'Copyright text (optional)',
      copyrightPlaceholder: 'e.g. All rights reserved.',
      termsUrl: 'Terms of use URL',
      privacyUrl: 'Privacy policy URL',
    },
    users: {
      listTitle: 'User list (clients + providers)',
      seedMissing: 'Create demo accounts (missing)',
      recreateDemo: 'Recreate demo accounts',
      seedConfirm: 'Delete and recreate only demo-*@nioland.local accounts? Other users are not affected.',
      demoUpdated: 'Demo accounts updated.',
      demoCreateFailed: 'Failed to create demo accounts.',
      demoRecreated: 'Demo accounts recreated.',
      demoRecreateFailed: 'Failed to recreate demo accounts.',
      refAccounts: 'Reference accounts:',
      refAccountsDesc: 'demo-admin@nioland.local (Admin123!), demo-client@nioland.local (Client123!), demo-prestataire@nioland.local (Prestataire123!). For development/demo use only.',
      addUser: 'Add a user',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      email: 'Email',
      password: 'Password',
      phone: 'Phone',
      user: 'user',
      provider: 'provider',
      adding: 'Adding...',
      addUserBtn: 'Add user',
      thName: 'Name',
      thEmail: 'Email',
      thPhone: 'Phone',
      thRole: 'Role',
      thActive: 'Active',
      thVerifStatus: 'Verif. status',
      thIaDocs: 'AI docs',
      thActions: 'Actions',
      closeAdd: 'Close add',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      editFormTitle: 'Edit form',
      clickEdit: 'Click "Edit".',
      account: 'Account:',
      editRole: 'Role',
      verifStatus: 'Verif. status',
      notes: 'Notes',
      accountActive: 'Active account',
      saving: 'Saving...',
      save: 'Save',
      cancel: 'Cancel',
    },
    stats: {
      users: 'Users',
      jobs: 'Jobs',
      completed: 'Completed services',
      revenue: 'Revenue (estimated)',
    },
    requests: {
      title: 'Request management',
      thClient: 'Client',
      thService: 'Service',
      thSubService: 'Sub-service',
      thStatus: 'Status',
      thPrice: 'Price',
    },
    categories: {
      title: 'Service Categories',
      desc: 'View all services and manage their categories. Categories are the sub-sectors that providers choose when registering.',
      overviewTitle: 'All Services',
      overviewDesc: 'Here are all the services in your platform. Each service can have multiple categories.',
      refresh: 'Refresh',
      initDefaults: 'Sync with default services',
      syncing: 'Syncing...',
      synced: 'Services synced with default data.',
      initFailed: 'Service initialization failed.',
      recreate: 'Reset all services to default',
      recreating: 'Resetting...',
      recreateConfirm: 'This will delete all current services and replace them with the default set. Providers will need to update their trade in their profile. Continue?',
      recreated: 'Services reset to default.',
      recreateFailed: 'Failed to reset services.',
      noServices: 'No services found.',
      thTitle: 'Service Name',
      thUrl: 'URL',
      thCategories: 'Categories',
      thProviders: 'Providers',
      thId: 'ID (_id)',
      manageCats: 'Manage Categories',
      manageCatsDesc: 'Select a service below to add, rename, or remove its categories.',
      service: 'Service',
      addCategory: 'Add a new category',
      categoryPlaceholder: 'E.g.: Countertop installation',
      adding: 'Adding...',
      addBtn: 'Add',
      addFailed: 'Category addition failed.',
      selectService: 'Select a service.',
      noCategories: 'No categories for this service yet.',
      thCategory: 'Category',
      edit: 'Edit',
      savingShort: 'Saving...',
      save: 'Save',
      cancel: 'Cancel',
      editFailed: 'Edit failed.',
      delete: 'Delete',
      deleteConfirm: 'Delete category "{{name}}"?',
      deleteFailed: 'Deletion failed.',
    },
    services: {
      validation: {
        titleRequired: 'Title is required.',
        titleTooLong: 'Title is too long.',
        descriptionTooLong: 'Description is too long.',
        invalidUrl: 'Invalid URL.',
      },
      title: 'Services Management',
      addNew: 'Add New Service',
      deleteSelected: 'Delete Selected',
      deleteConfirm: 'Are you sure you want to delete this service?',
      bulkDeleteTitle: 'Bulk Delete Services',
      bulkDeleteConfirm: 'Are you sure you want to delete {{count}} services? This action cannot be undone.',
      andMore: '...and {{count}} more',
      noServices: 'No services found',
      noServicesDesc: 'Create your first service to get started',
      showing: 'Showing {{count}} services',
      selected: '{{count}} selected',
      thTitle: 'Title',
      thDescription: 'Description',
      thCategories: 'Categories',
      thCover: 'Cover',
      thSlug: 'Slug',
      thSubServices: 'Sub-services',
      thStatus: 'Status',
      thCreated: 'Created',
      thActions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      hasImage: 'Has image',
      activate: 'Activate',
      deactivate: 'Deactivate',
      edit: 'Edit Service',
      createSuccess: 'Service created successfully.',
      updateSuccess: 'Service updated successfully.',
      deleteSuccess: 'Service deleted successfully.',
      filters: {
        title: 'Filters',
        reset: 'Reset',
        search: 'Search',
        searchPlaceholder: 'Search by title or description...',
        searchHelp: 'Search in service titles and descriptions',
        category: 'Category',
        allCategories: 'All categories',
        status: 'Status',
        allStatus: 'All status',
        sortBy: 'Sort by',
        sortOrder: 'Order',
        active: 'Active filters',
        sortByOptions: {
          created: 'Created date',
          title: 'Title',
          status: 'Status'
        },
        sortOrderOptions: {
          desc: 'Descending',
          asc: 'Ascending'
        }
      },
      form: {
        title: 'Title',
        titlePlaceholder: 'Enter service title',
        titleHelp: 'Maximum 100 characters',
        description: 'Description',
        descriptionPlaceholder: 'Enter service description',
        descriptionHelp: 'Maximum 1000 characters',
        cover: 'Cover Image URL',
        coverPlaceholder: 'https://example.com/image.jpg',
        coverHelp: 'Optional: URL to service cover image',
        tags: 'Tags',
        tagsPlaceholder: 'tag1, tag2, tag3',
        tagsHelp: 'Comma-separated list of tags',
        categories: 'Categories',
        categoriesPlaceholder: 'category1, category2, category3',
        categoriesHelp: 'Comma-separated list of categories',
        subServices: 'Sub-services',
        subServicesHelp: 'Add sub-service tiles with a key, optional label, and cover image path.',
        addSubService: 'Add sub-service',
        subServiceKey: 'Key (e.g. plomberie)',
        subServiceLabel: 'Label (optional, falls back to i18n)',
        subServiceCover: 'Cover image path (e.g. /images/plomberie.jpg)',
        featured: 'Featured',
        noSubServices: 'No sub-services added yet.',
        untitled: 'Untitled',
        description: 'Description',
        descriptionFrPlaceholder: 'Description in French...',
        descriptionEnPlaceholder: 'Description in English...',
        itemsList: 'Benefit / feature list',
        addItem: 'Add item',
        itemFrPlaceholder: 'Item in French',
        itemEnPlaceholder: 'Item in English',
        browse: 'Browse',
        imagePicker: 'Select an image',
        searchImages: 'Search images...',
        currentImage: 'Current image:',
        noImagesFound: 'No images found.',
        tabGeneral: 'General',
        tabCategories: 'Categories',
        tabSubServices: 'Sub-services',
        tabRouting: 'Routing & SEO',
        tabLibrary: 'Library',
        tabUpload: 'Upload',
        labelFr: 'Label (French)',
        labelEn: 'Label (English)',
        labelFrPlaceholder: 'e.g. Plomberie',
        labelEnPlaceholder: 'e.g. Plumbing',
        dropOrClick: 'Drop an image here or click to browse',
        uploadHelp: 'JPG, PNG, GIF, WebP, SVG — max 10 MB',
        uploading: 'Uploading...',
        uploadFailed: 'Upload failed. Please try again.',
        previewUrl: 'URL preview:',
        categoriesHelp: 'Add categories to group this service on the platform.',
        manage: 'Manage',
        editCategory: 'Edit category',
        categoryName: 'Category name',
        subServicesInCategory: 'Sub-services in this category',
        uncategorizedSubs: 'Uncategorized sub-services',
        uncategorizedHelp: 'Sub-services not linked to any category. Assign them from a category dialog.',
        slug: 'URL slug',
        slugPlaceholder: 'e.g. plomberie-chauffage',
        slugHelp: 'Used in the URL: /services/your-slug',
        subtitle: 'Page subtitle',
        subtitlePlaceholder: 'Short description shown on the category page',
        tilePrefix: 'Tile CSS prefix',
        tilePrefixPlaceholder: 'e.g. plumbing',
        tilePrefixHelp: 'CSS class prefix for tile styling (optional)',
        url: 'URL',
        isActive: 'Service is active',
        isActiveHelp: 'Inactive services will not be shown to users',
        create: 'Create Service',
        creating: 'Creating...',
        update: 'Update Service',
        updating: 'Updating...',
        validation: {
          titleRequired: 'Title is required',
          titleTooLong: 'Title must be less than 100 characters',
          descriptionTooLong: 'Description must be less than 1000 characters',
          invalidUrl: 'Please enter a valid URL',
          invalidJson: 'Invalid JSON format'
        }
      }
    },
    reviews: {
      title: 'Reviews & comments',
      desc: 'Feedback recorded on requests (average rating, comments) and provider evaluation support tickets.',
      withReviews: 'Requests with reviews / comments',
      thClient: 'Client',
      thService: 'Service',
      thRating: 'Rating',
      thComment: 'Comment',
      thDate: 'Date',
      noReviews: 'No review data on requests.',
      providerReviews: 'Customer reviews on providers',
      thProvider: 'Provider',
      noProviderReviews: 'No reviews published on providers.',
      savEvaluations: 'Evaluations (support tickets)',
      loadingTickets: 'Loading tickets…',
      thSubject: 'Subject',
      thStatus: 'Status',
      noEvalTickets: 'No evaluation tickets.',
    },
    outreach: {
      title: 'Contact messages & blog (MongoDB)',
      refresh: 'Refresh',
      contacts: 'Contact forms',
      contactsDesc: 'Collection',
      thDate: 'Date',
      thName: 'Name',
      thEmail: 'Email',
      thSubject: 'Subject',
      thMessage: 'Message',
      noMessages: 'No messages.',
      blogArticles: 'Blog articles (API)',
      blogDesc: 'Collection',
      thTitle: 'Title',
      thAuthor: 'Author',
      thCategory: 'Category',
      noArticles: 'No articles.',
    },
    support: {
      title: 'Support & after-sales (complaints, warranties, refunds…)',
      totalTickets: 'Total tickets',
      pending: 'Pending',
      inProgress: 'In progress',
      resolved: 'Resolved',
      byType: 'Distribution by request type',
      filterStatus: 'Status',
      all: 'All',
      filterType: 'Type',
      refresh: 'Refresh',
      loading: 'Loading…',
      noTickets: 'No tickets for these filters.',
      thDate: 'Date',
      thClient: 'Client',
      thType: 'Type',
      thSubject: 'Subject',
      thStatus: 'Status',
      thPriority: 'Priority',
      thAgent: 'Agent',
      thMessages: 'Messages',
      thActions: 'Actions',
      manage: 'Manage',
      deleteShort: 'Delete',
      ticket: 'Ticket',
      customer: 'Customer',
      createdOn: 'Created on',
      provider: 'Provider',
      reference: 'Reference',
      rating: 'Rating',
      initialDesc: 'Initial description',
      attachments: 'Attachments',
      attachment: 'Attachment',
      status: 'Status',
      priority: 'Priority',
      assignedAgent: 'Assigned agent',
      agentPlaceholder: 'E.g.: agent@nioland',
      saving: 'Saving…',
      save: 'Save',
      history: 'Message history',
      noMessages: 'No messages.',
      replyToCustomer: 'Reply to customer',
      replyPlaceholder: 'Your response…',
      sending: 'Sending…',
      sendReply: 'Send reply',
      close: 'Close',
    },
    payments: {
      title: 'Payments & Stripe transactions',
      payments: 'Payments',
      completed: 'Successful',
      pending: 'Pending',
      revenue: 'Revenue (TND)',
      filterStatus: 'Status',
      all: 'All',
      refresh: 'Refresh',
      loading: 'Loading…',
      noPayments: 'No payments for this filter.',
      thDate: 'Date',
      thClient: 'Client',
      thAmount: 'Amount',
      thCurrency: 'Currency',
      thDescription: 'Description',
      thMethod: 'Method',
      thStatus: 'Status',
      thStripeRef: 'Stripe Ref',
      onSite: 'On-site',
      card: 'Card',
    },
    savTypes: {
      reclamation: 'Complaint',
      remboursement: 'Refund request',
      'retour-produit': 'Product return',
      garantie: 'Warranty',
      'assistance-technique': 'Technical assistance',
      'suivi-intervention': 'Job tracking',
      'support-client': 'Customer support',
      'evaluation-prestataire': 'Provider evaluation',
      'signalement-probleme': 'Problem report',
      historique: 'Order/intervention history',
    },
    savStatus: {
      pending: 'Pending',
      'in-progress': 'In progress',
      resolved: 'Resolved',
    },
    savPriorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
    },
  },
  profile: {
    pageTitle: 'My profile',
    accountTitle: 'My account',
    loading: 'Loading your profile…',
    profileTitle: 'My profile',
    home: 'Home',
    afterSales: 'After-sales service',
    pay: 'Make a payment',
    myPaymentsTitle: 'My payment history',
    myPayments: 'My payments',
    noPayments: 'No payments yet. Pay for a service to see your history here.',
    makePayment: 'Make a payment',
    paymentDate: 'Date',
    paymentDesc: 'Description',
    paymentStatus: 'Status',
    paymentAmount: 'Amount',
    viewAllPayments: 'Make a new payment',
    paymentsLoading: 'Loading payments…',
    paymentsError: 'Could not load payment history.',
    providerSpace: 'Provider area',
    adminDashboard: 'Admin dashboard',
    editProfile: 'Edit my profile',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    logout: 'Log out',
    changePhoto: 'Change photo',
    addPhoto: 'Add a photo',
    profilePicture: 'Profile picture',
    registeredOn: 'Registered on',
    identity: 'Identity',
    roleAndType: 'Role and type',
    location: 'Location',
    providerInfo: 'Provider information',
    socialNetworks: 'Social networks and web',
    civility: 'Title',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    role: 'Role',
    providerType: 'Provider type',
    region: 'Region',
    city: 'City',
    address: 'Address',
    locationLabel: 'Location',
    sector: 'Business sector',
    subSector: 'Sub-sector',
    creationYear: 'Year of creation',
    registrationNumber: 'Registration number (SIRET)',
    vatNumber: 'VAT number',
    cinNumber: 'ID card number',
    companyType: 'Company type',
    legalForm: 'Legal form',
    businessName: 'Business name',
    experience: 'Experience',
    skills: 'Skills',
    qualifications: 'Qualifications',
    description: 'Description',
    about: 'About',
    clientCommitments: 'Client commitments',
    pricing: 'Pricing',
    schedule: 'Availability',
    coverageGuarantees: 'Coverage and guarantees',
    serviceArea: 'Service area',
    paymentMethod: 'Payment method',
    portfolio: 'Portfolio',
    linkedIn: 'LinkedIn',
    facebook: 'Facebook',
    twitter: 'Twitter / X',
    instagram: 'Instagram',
    website: 'Website',
    service: 'Service',
    subService: 'Sub-service',
    roles: {
      provider: 'Provider',
      user: 'User',
      admin: 'Admin',
    },
    userTypes: {
      company: 'Company',
      individual: 'Individual / Auto-entrepreneur',
    },
    deleteVerificationDocsConfirm: 'Delete your verification documents? This will reset your status to "pending".',
    emptyValue: '—',
    portfolioPhotos: '{{count}} photo',
    portfolioPhotos_plural: '{{count}} photos',
    portfolioVideos: '{{count}} video',
    portfolioVideos_plural: '{{count}} videos',
    portfolioProjects: '{{count}} file',
    portfolioProjects_plural: '{{count}} files',
    registeredOnDate: 'Registered on {{date}}',
  },
  pages: {
    notFoundTitle: 'Page not found',
    notFoundHeading: 'Oops, page not found.',
    notFoundBody: 'This page does not exist. Go back home to continue browsing Allo Alla.',
    goHome: 'Back to home',
    tryAgain: 'Try again',
    readFaqs: 'Read the FAQs',
    readFaqsDesc: 'Browse frequently asked questions for quick answers.',
    readFaqsLink: 'Read FAQs',
    helpSupport: 'Help & support',
    helpSupportDesc: 'Contact our team for any questions or assistance.',
    helpSupportLink: 'Help center',
  },
providerSignup: {
    pageTitle: 'Become a Service Provider',
    heading: 'Become a Service Provider',
    subtitle: 'Join our platform and start offering your services to clients. Add your photo, documents for the "Verified" badge, and your schedule to receive bookings.',
    selectedService: 'Selected service: {{name}}',
    successTitle: 'Registration successful!',
    successRedirect: 'Redirecting to the login page...',
    errorTitle: 'Error',
    toastSuccess: 'Registration successful',
    toastRedirect: 'Redirecting to login...',
    serviceDetails: 'Service Details',
    youAre: 'You are:',
    company: 'Company',
    individual: 'Individual',
    tradeLabel: 'Trade / Service:',
    mainService: 'Main service',
    serviceN: 'Service {{n}}',
    remove: 'Remove',
    service: 'Service',
    subService: 'Sub-service',
    selectService: 'Select a service',
    selectSubService: 'Select a sub-service',
    add: '+ ADD',
    loadingServices: 'Loading services...',
    tradeHint: 'For each row, choose a service then a sub-service (your choices are saved in the form). Click + ADD to show a new row with its own dropdown lists.',
    registrationNumber: 'UTR number or registration number',
    registrationPlaceholder: 'Enter registration number',
    yourPhoto: 'Your photo',
    profilePhoto: 'Profile photo',
    photoPreview: 'Preview',
    photoHint: 'Recommended format: JPG or PNG, max 5 MB',
    verifiedBadge: '"Verified" badge',
    verifiedDesc: 'Upload the required documents to obtain the "Verified" badge and build trust (ID, diplomas, certificates, etc.).',
    documents: 'Documents (PDF or images)',
    filesSelected: '{{count}} file(s) selected: {{names}}',
    cinPhoto: 'ID card photo (AI verification)',
    cinHint: 'Add a clear photo of your ID card for automatic verification.',
    workSchedule: 'Select working hours',
    workScheduleDesc: 'Set your hours to start receiving booking requests.',
    day: 'Day',
    open: 'Open',
    from: 'From',
    to: 'To',
    scheduleHint: 'Check "Open" and choose hours for each day.',
    scheduleNotes: 'Notes (optional)',
    scheduleNotesPlaceholder: 'E.g.: By appointment on weekends, or variable hours...',
    closed: 'Closed',
    coordinates: 'Contact details',
    address: 'Address',
    addressPlaceholder: 'Enter an address',
    lastName: 'Last name *',
    lastNamePlaceholder: 'Enter your last name',
    lastNameHidden: 'Will not be visible on the site',
    firstName: 'First name *',
    firstNamePlaceholder: 'Enter your first name',
    firstNameVisible: 'Will be visible on the site',
    email: 'Email address *',
    emailPlaceholder: 'Enter your email',
    phone: 'Mobile phone *',
    phonePlaceholder: 'Enter your number (8 digits)',
    region: 'Region *',
    selectRegion: 'Select a region',
    city: 'City *',
    selectCity: 'Select a city',
    proInfo: 'Professional information',
    businessName: 'Trade / Service offered *',
    businessPlaceholder: 'E.g.: Home plumber, Web developer, Housekeeper...',
    experience: 'Years of experience *',
    selectExperience: 'Select experience',
    exp01: '0-1 year',
    exp25: '2-5 years',
    exp610: '6-10 years',
    exp11: '11+ years',
    description: 'Availability and service description *',
    descriptionPlaceholder: 'E.g.: Available Monday to Friday, 9am-6pm. Describe your services, your approach, and what sets you apart...',
    qualifications: 'Skills',
    qualificationsPlaceholder: 'E.g.: Tile installation, emergency repairs, full renovation, etc.',
    pricing: 'Pricing',
    pricingPlaceholder: 'E.g.: €50/hour, €200 per job, custom quote...',
    accountInfo: 'Account Information',
    password: 'Password *',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm password *',
    confirmPasswordPlaceholder: 'Confirm your password',
    pwdLower: 'At least one lowercase letter',
    pwdUpper: 'At least one uppercase letter',
    pwdDigit: 'At least one digit',
    pwdLength: 'At least 12 characters',
    backToServices: '← Back to Services',
    submit: 'Register as Provider',
    submitting: 'Registering...',
    days: {
      lun: 'Monday', mar: 'Tuesday', mer: 'Wednesday', jeu: 'Thursday',
      ven: 'Friday', sam: 'Saturday', dim: 'Sunday',
    },
    errors: {
      tradeRequired: 'Please select at least one trade',
      tradeRequiredFull: 'Please select at least one trade / service.',
      subServiceRequired: 'Please select at least one sub-service for service « row {{line}} ».',
      registrationRequired: 'Registration number is required',
      lastNameRequired: 'Last name is required',
      lastNameMin: 'Last name must be at least 2 characters',
      firstNameRequired: 'First name is required',
      firstNameMin: 'First name must be at least 2 characters',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      phoneRequired: 'Phone number is required',
      phoneDigits: 'Number must contain 8 digits',
      regionRequired: 'Region is required',
      cityRequired: 'City is required',
      businessRequired: 'This field is required',
      experienceRequired: 'Experience is required',
      descriptionRequired: 'Description is required',
      descriptionMin: 'Description must be at least 20 characters',
      passwordRequired: 'Password is required',
      passwordCriteria: 'Password does not meet the criteria',
      confirmRequired: 'Please confirm your password',
      confirmMismatch: 'Passwords do not match',
      registerFailed: 'Registration failed. Please try again.',
      generic: 'An error occurred. Please try again.',
    },
  },
supportSav: {
    pageTitle: 'After-sales service',
    badge: 'Support',
    heading: 'After-sales service',
    subtitle: 'Complaints, refunds, warranties, job tracking, customer support… We are with you every step of the way.',
    statTotal: 'Total',
    statPending: 'Pending',
    statInProgress: 'In progress',
    statResolved: 'Resolved',
    tabNew: 'Contact support',
    tabList: 'My requests',
    tabListCount: 'My requests ({{count}})',
    requestType: 'Request type *',
    priority: 'Priority',
    subject: 'Subject *',
    subjectPlaceholder: 'E.g.: Defective product after delivery',
    reference: 'Job / order reference',
    referencePlaceholder: 'Order or job ID (optional)',
    provider: 'Provider involved',
    providerPlaceholder: 'Provider name (optional)',
    rating: 'Rating (1 to 5)',
    description: 'Detailed description *',
    descriptionPlaceholder: 'Describe your issue, expectations, dates, references...',
    attachments: 'Attachments (invoices, photos…)',
    attachmentsHint: 'Up to 5 files (images or PDF).',
    remove: 'Remove',
    notifyEmail: 'Email notifications',
    notifySMS: 'SMS notifications',
    submit: 'Submit request',
    submitting: 'Sending…',
    viewRequests: 'View my requests',
    historyTitle: 'My support request history',
    filterAll: 'All statuses',
    loading: 'Loading…',
    noTickets: 'No requests yet.',
    colDate: 'Date',
    colType: 'Type',
    colSubject: 'Subject',
    colStatus: 'Status',
    colPriority: 'Priority',
    colMessages: 'Messages',
    colActions: 'Actions',
    viewReply: 'View / Reply',
    modalTicket: 'Ticket',
    createdAt: 'Created on',
    status: 'Status',
    providerLabel: 'Provider',
    referenceLabel: 'Reference',
    assignedTo: 'Assigned agent',
    initialDescription: 'Initial description',
    attachmentsLabel: 'Attachments',
    attachmentN: 'Attachment {{n}}',
    exchanges: 'Messages',
    noMessages: 'No messages yet.',
    reply: 'Reply',
    replyPlaceholder: 'Your message…',
    attachFiles: 'Attach files (max 3)',
    send: 'Send',
    sending: 'Sending…',
    resolved: 'This request has been resolved.',
    close: 'Close',
    loadError: 'Unable to load tickets.',
    fileError: 'Error loading a file.',
    validationError: 'Please enter a subject and description.',
    submitSuccess: 'Your support request has been submitted. Our team will respond shortly.',
    submitError: 'Error submitting request.',
    messageError: 'Failed to send message.',
    types: {
      reclamation: 'Complaint',
      remboursement: 'Refund request',
      'retour-produit': 'Product return',
      garantie: 'Warranty',
      'assistance-technique': 'Technical assistance',
      'suivi-intervention': 'Job tracking',
      'support-client': 'Customer support (chat / email / phone)',
      'evaluation-prestataire': 'Provider evaluation',
      'signalement-probleme': 'Issue report',
      historique: 'Order / job history',
    },
    statuses: {
      pending: 'Pending',
      'in-progress': 'In progress',
      resolved: 'Resolved',
    },
    priorities: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
    },
  },




wizardQ: {
    "10": "10",
    "1_journee": "1 day",
    "1_a_3_mois": "1 to 3 months",
    "1_a_5_meubles": "1 to 5 pieces of furniture",
    "1_2": "1-2",
    "10_a_20": "10 to 20",
    "10_a_20_plants_petit_espace": "10 to 20 plants (small space)",
    "100l": "100L",
    "11_a_20_meubles": "11 to 20 pieces of furniture",
    "150l": "150L",
    "1er_etage": "1st floor",
    "2_a_4h": "2 to 4 hours",
    "2_a_5": "2 to 5",
    "2_3": "2-3",
    "20_a_50_plants_jardin_moyen": "20 to 50 plants (average garden)",
    "200l": "200L",
    "2eme_etage": "2nd floor",
    "3_points": "3 points",
    "3_6": "3-6",
    "300l": "300L",
    "30l": "30L",
    "3eme_etage_ou_plus": "3rd floor or more",
    "4_ou_plus": "4 or more",
    "5_points": "5 points",
    "5_a_10": "5 to 10",
    "50l": "50L",
    "6_a_10_meubles": "6 to 10 pieces of furniture",
    "80l": "80L",
    "acces_difficile": "Difficult access",
    "aide_aux_devoirs": "Homework help",
    "alarme_avec_camera": "Alarm with camera",
    "allergies_regime_special": "Allergies / Special diet",
    "aluminium_metal": "Aluminum / metal",
    "ambiance_lumiere_douce": "Ambiance (soft light)",
    "ameliorer_la_luminosite": "Improve brightness",
    "amenagement_optimisation_de_l_espace": "Space planning/optimization",
    "amenagement_apres_demenagement": "Arrangement after moving",
    "amenagement_complet": "Complete layout",
    "amenagement_decoratif_complet": "Complete decorative layout",
    "amenagement_interieur_tiroirs_etageres": "Interior layout (drawers, shelves, etc.)",
    "anti_humidite_moisissure": "Anti-humidity / mold",
    "apres_travaux": "After work",
    "arbustes_isoles": "Isolated shrubs",
    "armoire_dressing": "Wardrobe / Dressing room",
    "armoires_murales": "Wall cabinets",
    "assez_recent": "Fairly recent",
    "audio_multimedia": "Audio/multimedia",
    "aujourdhui": "Today",
    "aujourd_hui": "Today",
    "autonomie_complete": "Complete autonomy",
    "autre_adresse": "Other address",
    "avant_arriere": "Front + Back",
    "avec_ascenseur": "With elevator",
    "avec_camera": "With camera",
    "avec_des_arbres": "With trees",
    "avec_des_arbustes": "With shrubs",
    "avec_rangement": "With storage",
    "avec_transport": "With transport",
    "avec_une_ile": "With an island",
    "avez_vous_besoin_dun_monte_meuble": "Do you need a furniture lift?",
    "avez_vous_besoin_dun_service_de_montage": "Do you need an assembly service?",
    "aerer_une_pelouse": "Aerate a lawn",
    "balancoire": "Swing",
    "batterie_12v": "12V battery",
    "batterie_ve_haute_tension": "EV battery (High voltage)",
    "boheme": "Bohemia",
    "bois_dur": "Hardwood",
    "bois_massif": "Solid wood",
    "bon_etat": "Good condition",
    "boite_s_aux_lettres": "Mailbox(es)",
    "boite_s_a_cles": "Key box(es)",
    "bruit_grincement": "Noise / Squeaking",
    "bureau_local_pro": "Office / Professional premises",
    "bebe": "baby",
    "beton": "Concrete",
    "beton_cire": "Polished concrete",
    "cache": "Hidden",
    "camera": "Camera",
    "canalisation_bouchee": "Blocked pipe",
    "canape": "Couch",
    "canape_cuir": "Leather sofa",
    "canape_tissu": "Fabric sofa",
    "capot_integre": "Integrated hood",
    "capot_retractable": "Retractable hood",
    "carreaux_de_platre": "Plaster tiles",
    "carrelage_ceramique": "Tile/ceramic",
    "casse_structure": "Broken (structure)",
    "cave_grenier": "Cellar/Attic",
    "cave_grenier_garage": "Cellar/Attic/Garage",
    "cela_concerne": "This concerns:",
    "chambre_a_coucher": "Bedroom",
    "changement_piece_dusure": "Changing wearing parts",
    "changement_piece_mecanique": "Mechanical part change",
    "changement_piece_electrique": "Change electrical part",
    "changement_plusieurs_pieces": "Changing several parts",
    "chargement_dechargement": "Loading + Unloading",
    "chargement_dechargement_remontage_des_meubles": "Loading + Unloading + Reassembly of furniture",
    "chargement_dechargement_complet": "Full loading + unloading",
    "charniere": "Hinge",
    "charniere_abimee": "Damaged hinge",
    "chauffage_et_eau_chaude": "Heating and hot water",
    "chauffage_uniquement": "Heating only",
    "clairseme": "Sparse",
    "climatisation_faible": "Weak air conditioning",
    "cloisons_seches": "Drywall",
    "cloue": "Nailed",
    "cle_cassee": "Broken key",
    "cle_perdue": "Lost key",
    "colle": "Glue",
    "colonne_de_cabinet": "Cabinet column",
    "combien_darbres_sont_concernes": "How many trees are affected?",
    "combien_darbustes_cela_concerne_t_il": "How many shrubs does this affect?",
    "combien_delements_sont_impliques": "How many elements are involved?",
    "combien_de_fenetres_sont_concernees": "How many windows are affected?",
    "combien_de_pieces_sont_concernees": "How many parts are affected?",
    "combien_de_pieces_sont_concernees_facultatif": "How many parts are affected? (optional)",
    "combien_de_plants_de_fleurs_planter": "How many flower plants to plant?",
    "combien_d_elements_sont_concernes_facultatif": "How many elements are affected? (optional)",
    "compagnie_a_domicile": "Home company",
    "complete": "Complete",
    "conseils_en_decoration": "Decorating advice",
    "conseils_en_decoration_interieure": "Interior decoration advice",
    "conseils_en_eclairage": "Lighting advice",
    "controle_diagnostic": "Control / diagnosis",
    "controle_etriers": "Caliper control",
    "couloir_entree": "Corridor / Entrance",
    "couloir_etroit_escalier_en_colimacon": "Narrow corridor / spiral staircase",
    "creation_de_rangements": "Creation of storage",
    "creation_d_espace_de_rangement": "Creation of storage space",
    "creer_une_ambiance_chaleureuse": "Create a warm atmosphere",
    "creer_une_ambiance_specifique": "Create a specific atmosphere",
    "creez_un_potager": "Create a vegetable garden",
    "cuisine_principale": "Main kitchen",
    "cuisine_professionnelle": "Professional kitchen",
    "cuisine_secondaire": "Secondary kitchen",
    "cuisine_equipee": "Equipped kitchen",
    "cablage_et_tirage_de_cables": "Wiring and cable pulling",
    "cable": "Cable",
    "de_plein_air": "Outdoor",
    "de_quel_type_de_demande_sagit_il": "What type of request is this?",
    "de_quel_type_de_hotte_sagit_il": "What type of hood is this?",
    "de_quoi_avez_vous_besoin": "What do you need?",
    "demande_de_details": "Request details",
    "demi_journee": "Half day",
    "diagnostic_electronique": "Electronic diagnostics",
    "donnez_une_estimation_de_la_quantite_surface_facultatif": "Give an estimate of quantity/area (optional)",
    "donnez_une_estimation_des_elements_concernes_facultatif": "Give an estimate of the items involved (optional)",
    "donnez_une_estimation_du_nombre_de_meubles_facultatif": "Give an estimate of the number of furniture (optional)",
    "donnez_une_estimation_du_nombre_de_portes_facultatif": "Give an estimate of the number of doors (optional)",
    "donnez_une_estimation_du_nombre_de_robinets_facultatif": "Give an estimate of the number of taps (optional)",
    "donnez_une_estimation_du_nombre_d_elements_facultatif": "Give an estimate of the number of items (optional)",
    "donnez_une_estimation_du_nombre_d_elements_concernes_facultatif": "Give an estimate of the number of items involved (optional)",
    "douche_bain": "Shower / Bath",
    "duree_du_stockage": "Storage duration:",
    "duree_estimee": "Estimated duration:",
    "duree_et_frequence": "Duration and frequency:",
    "duree_souhaitee": "Desired duration:",
    "debarras_complet": "Complete clearance",
    "debarras_partiel": "Partial clearance",
    "debouchage": "Unblocking",
    "deboucher_les_canalisations": "Unblock the pipes",
    "dechargement": "Unloading",
    "dechargement_seul": "Unloading alone",
    "decoratif": "Decorative",
    "decoration_d_un_espace": "Decorating a space",
    "decouper_un_arbre": "Cut down a tree",
    "decrivez_la_vegetation_de_la_zone_a_defricher": "Describe the vegetation in the area to be cleared.",
    "decrivez_votre_projet": "Describe your project",
    "deja_montes": "Already assembled",
    "demontage": "Disassembly",
    "demontage_montage": "Disassembly + Assembly",
    "demontage_et_installation": "Disassembly and installation",
    "demonter": "Disassemble",
    "demonter_et_remonter": "Disassemble and reassemble",
    "depannage": "Troubleshooting",
    "depannage_reparation_rapide": "Troubleshooting (quick repair)",
    "depannage_sur_place": "On-site troubleshooting",
    "depannage_urgence": "Emergency repair",
    "depannage_urgent": "Urgent repair",
    "depasse": "Exceeds",
    "deplacer_les_tuyaux": "Move the pipes",
    "depose_et_pose_de_pavage_exterieur": "Removal and installation of exterior paving",
    "deposer_et_installer_les_joints": "Remove and install seals",
    "deposer_et_installer_un_appareil_electromenager": "Removing and installing a household appliance",
    "desherbage": "Weeding",
    "desodorisation": "Deodorization",
    "detachage": "Stain removal",
    "details": "Details",
    "details_de_votre_demande": "Details of your request",
    "details_supplementaires": "Additional Details",
    "detartrage_des_canalisations": "Descaling of pipes",
    "detecteur": "Detector",
    "detecteurs_animaux": "Animal detectors",
    "eau_chaude_uniquement": "Hot water only",
    "en_bon_etat": "In good condition",
    "en_coupe": "Sectional",
    "en_haut_et_par_dessus": "Up and over",
    "en_profondeur": "In depth",
    "enduits_decoratifs_stuc_personnel": "Decorative coatings: stucco, personal",
    "enlevement_encombrants": "Bulky removal",
    "enlevement_uniquement": "Collection only",
    "entre_1_et_2_metres": "Between 1 and 2 meters",
    "entre_10_et_30_metres": "Between 10 and 30 meters",
    "entre_2_et_3_metres": "Between 2 and 3 meters",
    "entretien_detartrage": "Maintenance / descaling",
    "entretien_regulier": "Regular maintenance",
    "entretien_regulier_nettoyage_protection": "Regular maintenance (cleaning, protection)",
    "entree_principale": "Main entrance",
    "est_il_necessaire_de_creer_un_nouveau_circuit_electrique_coupe_passage_de_cables_tirage_de_fil": "Is it necessary to create a new electrical circuit (cutting, passing cables, pulling wire, etc.)?",
    "esthetique": "Aesthetic",
    "esthetique_embellir": "Aesthetics (embellish)",
    "exemple_1_porte": "Example: 1 door",
    "exemple_1_robinet": "Example: 1 tap",
    "exemple_1_evier": "Example: 1 sink",
    "exemple_10": "Example: 10",
    "exemple_15": "Example: 15",
    "exemple_2": "Example: 2",
    "exemple_2_meubles": "Example: 2 pieces of furniture",
    "exemple_2_equipements": "Example: 2 pieces of equipment",
    "exemple_20": "Example: 20",
    "exemple_20_m": "Example: 20 m²",
    "exemple_200": "Example: 200",
    "exemple_25_m": "Example: 25 m²",
    "exemple_28": "Example: 28",
    "exemple_3_rangements": "Example: 3 storage spaces",
    "exemple_3_elements": "Example: 3 elements",
    "exemple_30": "Example: 30",
    "exemple_350": "Example: 350",
    "exemple_6_m": "Example: 6 m²",
    "existe_t_il_un_conduit": "Is there a conduit?",
    "extension_systeme": "System expansion",
    "exterieur": "Outside",
    "exterieures": "Exterior",
    "faire_un_tas": "Make a pile",
    "faudra_t_il_vider_la_ou_les_pieces": "Will the room(s) need to be emptied?",
    "faut_il_refaire_les_bordures_de_la_pelouse": "Should the lawn edges be redone?",
    "fenetre_a_double_battant": "Double-leaf window",
    "fenetre_a_un_seul_battant": "Single leaf window",
    "fer_forge": "Wrought iron",
    "feuilles_caduques": "Deciduous leaves",
    "feuilles_persistantes": "Evergreen leaves",
    "fissure": "Crack",
    "fixe": "Fixed",
    "fonctionnalite": "Functionality",
    "frequence": "Frequency :",
    "gagner_en_fonctionnalite": "Gain functionality",
    "gain_d_espace": "Space saving",
    "garde_meublee": "Furnished guard",
    "garde_a_domicile": "Home care",
    "goutte_a_goutte": "Drip",
    "grand_menage": "Big cleaning",
    "grande_taille": "Large size",
    "gros_volume": "Large volume",
    "geometrie": "Geometry",
    "geothermie": "Geothermal energy",
    "haie_dense_compacte": "Dense/compact hedge",
    "haie_legere": "Light hedge",
    "haie_mixte": "Mixed hedge",
    "haute_securite": "High security",
    "hauteur_etages": "Height (floors)",
    "hopital_clinique": "Hospital/Clinic",
    "il_me_faut_un_broyeur": "I need a grinder",
    "immediate": "Immediate",
    "impermeabilisation": "Waterproofing",
    "inacheve": "Unfinished",
    "indiquez_une_quantite": "Indicate a quantity",
    "informations_generales": "General information",
    "installation_equipements_neufs": "Installation (new equipment)",
    "installation_amelioration_de_l_eclairage": "Lighting installation/improvement",
    "installation_cameras": "Camera installation",
    "installation_de_decoration_murale": "Wall decoration installation",
    "installation_de_raccordement_a_la_terre": "Earth connection installation",
    "installation_du_drainage": "Installation of drainage",
    "installation_porte_blindee": "Armored door installation",
    "installer_un_appareil_menager": "Install a household appliance",
    "installer_un_systeme_de_plomberie": "Install a plumbing system",
    "installer_une_cuisine": "Install a kitchen",
    "installer_une_tige": "Install a rod",
    "installer_uniquement_les_joints": "Install only the gaskets",
    "interphone_audio": "Audio intercom",
    "interphone_audio_video": "Audio/video intercom",
    "interieur_exterieur": "Interior + Exterior",
    "interieur_sale": "Dirty interior",
    "interieures": "Interior",
    "inegal": "Unequal",
    "je_ne_sais_pas": "I don't know",
    "journee": "Daytime",
    "journee_complete": "Full day",
    "lave_vaisselle": "Dishwasher",
    "le_revetement_de_sol_existant_doit_il_etre_retire": "Should existing flooring be removed?",
    "le_revetement_mural_ou_de_sol_existant_doit_il_etre_retire_au_prealable": "Should the existing wall or floor covering be removed first?",
    "le_sol_est_il_pret_a_etre_plante": "Is the soil ready for planting?",
    "les_carreaux_doivent_etre_poses": "The tiles must be laid",
    "les_deux": "Both",
    "linge_de_maison": "Household linens",
    "local_commercial": "Commercial premises",
    "local_pro": "Professional premises",
    "local_professionnel": "Professional premises",
    "leger": "Light",
    "mdf_agglomere": "MDF / Chipboard",
    "machine_a_laver": "Washing machine",
    "maison_complete": "Complete house",
    "materiaux": "Materials",
    "mauvais_etat": "Bad condition",
    "mauvaise_evacuation": "Poor evacuation",
    "meilleure_organisation": "Better organization",
    "mettre_dans_sacs": "Put in bags",
    "mettre_en_avant_certains_elements": "Highlight certain elements",
    "mettre_en_lumiere": "Highlight",
    "mettre_le_tableau_electrique_aux_normes": "Bring the electrical panel up to standard",
    "meuble_tv": "TV cabinet",
    "meuble_ancien": "Old furniture",
    "meuble_exterieur": "Outdoor furniture",
    "meubles_poussieres": "Furniture & dust",
    "meubles_bas": "Low furniture",
    "meubles_sous_evier": "Furniture under sink",
    "meubles_volumineux_dressing_bibliotheque_etc": "Bulky furniture (dressing room, bookcase, etc.)",
    "micro_ondes": "Microwave",
    "moderniser_la_decoration": "Modernize the decoration",
    "modification_ou_creation_de_conduits": "Modification or creation of conduits",
    "moins_d1_mois": "Less than 1 month",
    "moins_d1_metre": "Less than 1 meter",
    "moins_de_10": "Less than 10",
    "moins_de_10_metres": "Less than 10 meters",
    "moins_de_2h": "Less than 2 hours",
    "montage_equilibrage": "Assembly + Balancing",
    "motoriser_le_portail_existant": "Motorize the existing gate",
    "motoriser_le_volet_existant": "Motorize the existing shutter",
    "moyen_volume": "Medium volume",
    "moyenne_5_a_10_cm": "Medium (5 to 10 cm)",
    "melange_de_plusieurs_types": "Mixture of several types",
    "menage_complet": "Complete household",
    "metal": "Metal",
    "metal_bois": "Metal + wood",
    "ne_demarre_pas": "Does not start",
    "nettoyage_apres": "Cleaning after",
    "nettoyage_interieur": "Interior cleaning",
    "nettoyer_canapes": "Clean Sofas",
    "nettoyer_tapis": "Clean Carpet",
    "neufs_en_kit": "New (in kit)",
    "niveau_de_nettoyage": "Cleaning level:",
    "niveau_de_securite": "Security level:",
    "niveau_du_sol": "Ground level",
    "nombre_delements": "Number of elements",
    "nombre_detages_approximatif": "Approximate number of floors:",
    "nombre_de_vitres": "Number of windows:",
    "non_aucun_travail_preparatoire_nest_necessaire": "No, no preparatory work is necessary.",
    "non_cest_a_lartisan_dapporter_lequipement": "No, it is up to the craftsman to provide the equipment.",
    "non_il_faut_tirer_un_cable": "No, you have to pull a cable.",
    "non_je_men_occuperai_moi_meme": "No, I'll take care of it myself.",
    "non_les_artisans_doivent_venir_avec_lequipement": "No, the craftsmen must come with the equipment.",
    "non_a_creer": "No, to create",
    "nouvelle_installation": "New installation",
    "objet_s_decoratif_s": "Decorative object(s)",
    "objets_de_valeur": "Valuables",
    "objets_decoratifs": "Decorative objects",
    "organisation_complete": "Complete organization",
    "oui_aide_chargement": "Yes + loading help",
    "oui_deja_installe": "Yes, already installed",
    "oui_je_dispose_du_materiel_necessaire": "Yes, I have the necessary equipment",
    "oui_le_sol_est_pret": "Yes, the floor is ready",
    "oui_les_bords_de_certains_elements_par_exemple_les_prises_les_portes": "Yes, the edges of certain elements (for example sockets, doors, etc.)",
    "oui_a_installer": "Yes, to install",
    "ou_avez_vous_achete_vos_meubles_de_cuisine_facultatif": "Where did you buy your kitchen furniture? (optional)",
    "ou_se_fera_l_installation_des_meubles": "Where will the furniture be installed?",
    "ou_se_fera_l_intervention": "Where will the intervention take place?",
    "ou_souhaitez_vous_effectuer_votre_travail": "Where do you want to do your work?",
    "panne_d_equipement": "Equipment failure",
    "panneau_de_controle": "Control panel",
    "panneaux_en_pvc_ou_stratifies": "PVC or laminated panels",
    "papier_peint": "Wallpaper",
    "particulierement_bas": "Particularly low",
    "particulierement_eleve": "Particularly high",
    "pas_dacces_vehicule": "No vehicle access",
    "pave": "Pavement",
    "perte_de_puissance": "Loss of power",
    "perte_d_autonomie": "Loss of autonomy",
    "petit_volume": "Small volume",
    "petite_taille": "Small size",
    "pierres_naturelles": "Natural stones",
    "piece_principale": "Main room:",
    "plafond_eclairage_general": "Ceiling (general lighting)",
    "plan_d_amenagement": "Development plan",
    "planter_un_ou_plusieurs_arbustes": "Plant one or more shrubs",
    "plantes_herbacees": "Herbaceous plants",
    "plantez_un_arbre": "Plant a tree",
    "plaque_de_platre": "Plasterboard",
    "plaquette_arriere": "Back plate",
    "plaquette_avant": "Front plate",
    "plateau_coulissant": "Sliding tray",
    "pliage_parfait": "Perfect folding",
    "plus_de_10": "More than 10",
    "plus_de_10_chambres": "More than 10 rooms",
    "plus_de_10_pieces": "More than 10 pieces",
    "plus_de_20": "More than 20",
    "plus_de_3_mois": "More than 3 months",
    "plus_de_3_metres": "More than 3 meters",
    "plus_de_30_metres": "More than 30 meters",
    "plus_de_4h": "More than 4 hours",
    "plus_de_6": "More than 6",
    "plusieurs_enfants": "Several children",
    "plusieurs_jours": "Several days",
    "platre_decoratif": "Decorative plaster",
    "platre_ou_stuc": "Plaster or stucco",
    "poignee_cassee": "Broken handle",
    "portail_autoportant": "Freestanding gate",
    "portail_battant": "Swing gate",
    "portail_coulissant": "Sliding gate",
    "porte_appartement": "Apartment door",
    "porte_avec_miroir_integre": "Door with integrated mirror",
    "porte_blindee": "Armored door",
    "porte_bloquee": "Door blocked",
    "porte_claquee": "Slammed door",
    "porte_d_entree": "Entrance door",
    "porte_interieure": "Interior door",
    "porte_maison": "House door",
    "porte_paliere": "Landing door",
    "porte_standard": "Standard door",
    "porte_vitree": "Glass door",
    "porte_fenetre": "French window",
    "pose_de_pavage_exterieur": "Laying exterior paving",
    "pose_d_etageres_decoratives": "Installation of decorative shelves",
    "poele": "Stove",
    "prise_interrupteur_connecte": "Connected socket/switch",
    "produits_ecologiques": "Ecological products",
    "programmee": "Scheduled",
    "precisez_le_type_et_la_quantite_de_tringles_a_rideaux": "Specify the type and quantity of curtain rods:",
    "precisez_vos_besoins_la_surface_a_traiter_letat_actuel_du_sol": "Specify your needs, the surface to be treated, the current state of the ground...",
    "precisions_sur_votre_demande": "Details of your request",
    "preparation_necessaire": "Necessary preparation",
    "pret_a_carreler": "Ready to tile",
    "pedale_molle": "Soft pedal",
    "que_faut_il_faire_des_feuilles_ramassees": "What should you do with the collected leaves?",
    "que_faut_il_faire_pour_votre_projet": "What needs to be done for your project?",
    "que_souhaitez_vous": "What do you want?",
    "que_souhaitez_vous_comme_accompagnement": "What support would you like?",
    "que_souhaitez_vous_comme_service": "What service do you want?",
    "que_souhaitez_vous_construire_avec_des_plaques_de_platre": "What do you want to build with plasterboard?",
    "que_souhaitez_vous_faire": "What do you want to do?",
    "que_souhaitez_vous_nettoyer": "What do you want to clean?",
    "que_souhaitez_vous_realiser": "What do you want to achieve?",
    "quel_est_votre_besoin_principal": "What is your main need?",
    "quel_type_de_chauffe_eau_facultatif": "What type of water heater (optional)",
    "quel_type_de_haie_souhaitez_vous_tailler": "What type of hedge do you want to trim?",
    "quel_type_de_meubles_aimeriez_vous_creer": "What type of furniture would you like to create?",
    "quel_type_de_pavage_souhaitez_vous": "What type of paving do you want?",
    "quel_type_de_revetement_de_sol_est_actuellement_installe": "What type of flooring is currently installed?",
    "quel_type_de_revetement_de_sol_faut_il_enlever": "What type of flooring should be removed?",
    "quel_type_de_revetement_mural_est_prevu": "What type of wall covering is planned?",
    "quel_type_de_travaux_de_platrerie_souhaitez_vous_realiser": "What type of plastering work do you want to carry out?",
    "quel_type_d_espace": "What type of space?",
    "quel_type_d_etagere_souhaitez_vous_installer_precisez_la_quantite": "What type of shelf do you want to install? Specify the quantity.",
    "quel_element_necessite_une_intervention_facultatif": "Which element requires intervention (optional)?",
    "quelle_est_la_forme_du_dressing_facultatif": "What is the shape of the dressing room (optional)?",
    "quelle_est_la_hauteur_approximative_de_lherbe": "Approximately how tall is the grass?",
    "quelle_est_la_hauteur_approximative_du_meuble_a_creer_en_cm_facultatif": "What is the approximate height of the furniture to be created, in cm? (optional)",
    "quelle_est_la_hauteur_de_la_haie_facultatif": "How high is the hedge? (optional)",
    "quelle_est_la_hauteur_du_portail_en_cm_facultatif": "What is the height of the gate in cm? (optional)",
    "quelle_est_la_largeur_du_portail_en_cm_facultatif": "What is the width of the gate in cm? (optional)",
    "quelle_est_la_longueur_approximative_du_meuble_a_realiser_en_cm_facultatif": "What is the approximate length of the furniture to be made, in cm? (optional)",
    "quelle_est_la_longueur_de_la_haie_en_cm_facultatif": "What is the length of the hedge in cm? (optional)",
    "quelle_est_la_longueur_totale_du_dressing": "What is the total length of the dressing room?",
    "quelle_est_la_marque_de_la_cuisine_facultatif": "What is the brand of the kitchen? (optional)",
    "quelle_est_la_marque_du_meuble_concerne_facultatif": "What is the brand of the furniture in question? (Optional)",
    "quelle_est_la_nature_de_votre_demande": "What is the nature of your request?",
    "quelle_est_la_profondeur_du_meuble_a_creer_en_cm_facultatif": "What is the depth of the furniture to be created, in cm? (optional)",
    "quelle_est_la_superficie_de_la_pelouse_en_m_facultatif": "What is the surface area of ​​the lawn in m²? (optional)",
    "quelle_est_la_superficie_de_pelouse_a_entretenir_en_m_facultatif": "What is the area of ​​lawn to maintain, in m²? (optional)",
    "quelle_est_la_superficie_du_potager_en_m_facultatif": "What is the surface area of ​​the vegetable garden in m²? (optional)",
    "quelle_est_la_superficie_totale_de_la_zone_concernee_en_m2": "What is the total surface area of ​​the area concerned in m2?",
    "quelle_est_la_superficie_totale_en_metres_carres": "What is the total area in square meters?",
    "quelle_est_la_surface_approximative_facultatif": "What is the approximate surface area? (optional)",
    "quelle_est_la_surface_approximative_a_deneiger_en_m_facultatif": "What is the approximate surface area to be cleared of snow (in m²)? (optional)",
    "quelle_est_la_surface_de_la_terrasse_en_m2": "What is the surface area of ​​the terrace in m2?",
    "quelle_est_la_surface_a_carreler_en_m": "What is the surface area to be tiled in m²?",
    "quelle_est_la_surface_a_couvrir_en_m_facultatif": "What is the surface area to be covered in m²? (optional)",
    "quelle_est_la_surface_a_couvrir_en_metres_carres": "What is the surface area to be covered in square meters?",
    "quelle_est_la_surface_a_maintenir_en_m_facultatif": "What is the surface area to maintain in m²? (optional)",
    "quelle_est_la_surface_a_peindre_en_m_facultatif": "What is the surface area to be painted in m²? (optional)",
    "quelles_sont_les_chambres_concernees": "Which rooms are affected?",
    "quelles_surfaces_doivent_etre_peintes": "What surfaces should be painted?",
    "quelques_heures": "A few hours",
    "quels_sont_les_elements_concernes": "What are the elements concerned?",
    "quels_elements_de_salle_de_bains_faut_il_assembler": "What bathroom elements should be assembled?",
    "radiateur_a_eau_chaude": "Hot water radiator",
    "radiateur_electrique": "Electric radiator",
    "ramassage_livraison": "Pickup & Delivery",
    "rangement_dune_piece": "Room storage",
    "recharge_depannage": "Charging / Troubleshooting",
    "recommandations_detaillees": "Detailed recommendations",
    "remettez_en_place_une_tige_existante": "Replace an existing rod",
    "remplacement_batterie": "Battery replacement",
    "remplacement_de_vitre": "Glass replacement",
    "remplacement_d_equipements": "Equipment replacement",
    "rendez_vous_medical": "Medical appointment",
    "repassage_delicat": "Delicate ironing",
    "retirer_un_appareil_menager": "Removing a household appliance",
    "revetement": "Coating",
    "revetement_exterieur": "Exterior covering",
    "revetement_mural": "Wall covering",
    "revetement_texture": "Textured coating",
    "rez_de_chaussee": "Ground floor",
    "robinet_bloque": "Blocked faucet",
    "rotin_osier": "Rattan / wicker",
    "rue_etroite": "Narrow street",
    "reamenagement_optimisation_de_l_espace": "Redevelopment (space optimization)",
    "reamenagement_avec_eclairage_decoratif": "Redevelopment with decorative lighting",
    "refrigerateur": "Fridge",
    "reglage": "Setting",
    "reglage_ajustement": "Adjustment/adjustment",
    "reglage_de_pression": "Pressure adjustment",
    "regulier": "Regular",
    "renovation": "Renovation",
    "renovation_poncage_peinture": "Renovation (sanding, painting)",
    "renovation_complete": "Complete renovation",
    "renovation_legere_poncage_vernis": "Light renovation (sanding, varnish)",
    "renover_linstallation_electrique": "Renovate the electrical installation",
    "reparation": "Repair",
    "reparation_charniere_poignee": "Repair (hinge, handle, etc.)",
    "reparation_fuite_casse": "Repair (leak, breakage, etc.)",
    "reparation_fuite_dysfonctionnement": "Repair (leak, malfunction)",
    "reparation_alarme": "Alarm repair",
    "reparation_cameras": "Camera repair",
    "reparation_crevaison": "Puncture repair",
    "reparation_de_charnieres": "Hinge repair",
    "reparation_de_fissures": "Crack repair",
    "reparation_de_tiroirs_portes": "Drawer/door repair",
    "reparation_simple_vis_fixation_ajustement": "Simple repair (screws, fixing, adjustment)",
    "reparation_structurelle_cassure_pied_cadre": "Structural repair (break, foot, frame, etc.)",
    "reparer_la_piece_defectueuse": "Repair the defective part",
    "reparer_le_cadre": "Repair the frame",
    "reparer_un_appareil_electromenager": "Repair a household appliance",
    "reversible": "Reversible",
    "revision": "Revision",
    "revision_freins_complete": "Complete brake overhaul",
    "saisissez_le_nom_de_la_marque": "Enter the brand name",
    "salle_de_bain": "Bathroom",
    "sans_ascenseur": "Without elevator",
    "sans_fil": "Wireless",
    "sans_transport": "Without transport",
    "sera_t_il_necessaire_de_couper": "Will it be necessary to cut?",
    "serrure_bloquee": "Lock stuck",
    "serrure_defectueuse": "Faulty lock",
    "serrure_a_cle": "Key lock",
    "sirene": "Siren",
    "souhaiteriez_vous_une_citerne": "Would you like a cistern?",
    "sous_sol": "Basement",
    "spot_encastre": "Recessed spotlight",
    "stockage_court_terme": "Short term storage",
    "stockage_long_terme": "Long term storage",
    "stratifie": "Laminate",
    "supprimer_et_installer": "Remove and install",
    "sur_le_mur": "On the wall",
    "sur_le_sol": "On the floor",
    "systeme_de_securite": "Security system",
    "systeme_multipoints": "Multi-point system",
    "systeme_split": "Split system",
    "systeme_a_double_flux": "Dual flow system",
    "systeme_a_flux_unique": "Single flow system",
    "systeme_a_humidite_controlee": "Humidity-controlled system",
    "seche_serviettes": "Towel dryer",
    "sechoir": "Dryer",
    "securite_zones_humides": "Safety (wet areas)",
    "selectionnez_le_ou_les_appareils_concernes": "Select the device(s) concerned?",
    "selectionnez_une_reponse": "Select an answer",
    "taille_standard": "Standard size",
    "texture": "Texture",
    "tiroir_bloque": "Blocked drawer",
    "toilettes_separees": "Separate toilets",
    "tout_evacuer": "Evacuate everything",
    "traitement_du_bois_anti_insectes_anti_humidite": "Wood treatment (anti-insect, anti-humidity)",
    "transplanter_larbre_s": "Transplant the tree(s)",
    "transplanter_le_s_arbuste_s": "Transplant the shrub(s)",
    "travaux_de_terrassement": "Earthworks",
    "travaux_decoratifs": "Decorative works",
    "tri_debarras": "Sorting + Clearance",
    "tri_recyclage": "Sorting + recycling",
    "tringle_a_vetements": "Clothes rail",
    "tres_dense": "Very dense",
    "tres_grand": "Very large",
    "tres_haute_securite": "Very high security",
    "tres_epais": "Very thick",
    "type_darticle_concerne_precisez_la_quantite": "Type of item concerned, specify quantity:",
    "type_darticle_s_a_monter_precisez_la_quantite": "Type of item(s) to be assembled, specify the quantity:",
    "type_de_batterie": "Battery Type :",
    "type_de_cameras": "Type of cameras:",
    "type_de_meubles_concernes_selection_multiple_possible": "Type of furniture concerned: (multiple selection possible)",
    "type_de_porte_de_garage": "Garage door type",
    "type_de_porte_de_garage_type_de_port": "Garage door type:",
    "type_de_prestation_souhaitee": "Type of service desired:",
    "type_de_repassage": "Ironing type:",
    "type_de_salle_de_bain": "Bathroom type:",
    "type_de_vehicule": "Vehicle type:",
    "type_d_alarme": "Alarm type:",
    "type_d_intervention_souhaitee": "Type of intervention desired",
    "type_d_utilitaire": "Utility type:",
    "telecommande": "Remote",
    "telesurveillance": "Remote monitoring",
    "televiseur_s": "Television(s)",
    "un_appartement": "An apartment",
    "un_bureau": "An office",
    "un_ensemble_a_definir": "A set to be defined",
    "une_maison": "A house",
    "unite_de_base": "Basic unit",
    "unite_haute": "High unit",
    "unite_murale": "Wall unit",
    "unite_portable": "Portable unit",
    "urgence": "Emergency :",
    "usure_normale": "Normal wear",
    "vitres_exterieures": "Exterior windows",
    "vitres_interieures": "Interior windows",
    "volume_a_debarrasser": "Volume to dispose of:",
    "vos_stores_sont": "Your blinds are",
    "votre_deck_facultatif": "Your deck (optional)",
    "votre_systeme_electrique": "Your electrical system",
    "voyant_allume": "Light on",
    "venitien": "Venetian",
    "verification_generale": "General check",
    "vetements": "Clothes",
    "amenagement_des_espaces": "layout of spaces",
    "appareil_menager": "household appliance",
    "appareils_menagers": "household appliances",
    "application_mobile": "mobile app",
    "assemblee": "assembly",
    "beton_poli": "polished concrete",
    "beton_poli_beton_poli": "polished concrete",
    "camera_camera": "camera",
    "canne_classique": "classic cane",
    "cloisons_seches_cloisons_sec": "drywall",
    "commande_vocale": "voice control",
    "conseil_en_decoration": "decoration advice",
    "conseils_en_decoration_conseils_en_": "decoration advice",
    "dalle_de_beton": "concrete slab",
    "dalle_exterieur": "exterior slab",
    "dalles_exterieur": "exterior slabs",
    "densite_moyenne": "medium density",
    "decoration_et_amenagement_des_espaces": "decoration and layout of spaces",
    "decoration_murale": "wall decoration",
    "decoration_murale_et_accessoires": "wall decoration and accessories",
    "demonter_demonter": "disassemble",
    "depannage_depannage": "troubleshooting",
    "entretien_et_depannage": "maintenance and troubleshooting",
    "exemple_10_exemple_10": "example: 10",
    "exemple_12": "example: 12",
    "exemple_175": "example: 175",
    "exemple_2_exemple_2": "example: 2",
    "exemple_20_exemple_20": "example: 20",
    "exemple_3": "example: 3",
    "exemple_300": "example: 300",
    "exemples_17": "examples: 17",
    "hotte_aspirante": "extractor hood",
    "hotte_filtrante": "filter hood",
    "hotte_murale": "wall hood",
    "installation_de_terrasse_en_bois": "wooden deck installation",
    "is_active": "is-active",
    "lit_de_sable": "sand bed",
    "machine_a_laver_machine_a_la": "washing machine",
    "marque_de_meubles": "furniture brand",
    "maconnerie": "masonry",
    "metres_lineaires_pour_votre_cuisine_ex_3": "linear meters for your kitchen (e.g.: 3)",
    "papier_peint_papier_peint": "wallpaper",
    "pavage_exterieur": "exterior paving",
    "plaque_de_cuisson": "cooktop",
    "plaque_de_platre_plaque_de_pl": "plasterboard",
    "plaque_platre": "plasterboard",
    "plaques_de_platre": "plasterboard",
    "plaques_platre": "plasterboard",
    "platrage": "plastering",
    "platrerie": "plastering",
    "pompe_a_chaleur": "heat pump",
    "renouvellement_des_plantes": "plant renewal",
    "reparation_des_meubles": "furniture repair",
    "reparation_meuble": "furniture repair",
    "revetement_de_sol": "flooring",
    "revetement_mural_revetement_m": "wall covering",
    "revetement_de_sol_revetement_d": "flooring",
    "reparation_de_meubles": "furniture repair",
    "reparation_des_meubles_reparation_d": "furniture repair",
    "reparation_meuble_reparation_m": "furniture repair",
    "socles_reglables": "adjustable bases",
    "tringle_a_rideaux": "curtain rod",
    "tringle_a_rideaux_tringle_a_ri": "curtain rod",
    "tringles_a_rideaux": "curtain rods",
    "tringles_a_rideaux_tringles_a_r": "curtain rods",
    "videosurveillance": "video surveillance",
    "journee_journee": "½ day",
    "a_convenir": "To be agreed",
    "a_discuter": "To discuss",
    "a_discuter_avec_lartisan": "To discuss with the craftsman",
    "a_discuter_avec_l_artisan": "To discuss with the craftsman",
    "a_definir": "To be defined",
    "a_definir_avec_lartisan": "To be defined with the craftsman",
    "a_definir_avec_le_prestataire": "To be defined with the service provider",
    "a_definir_avec_l_artisan": "To be defined with the craftsman",
    "a_definir_ensemble": "To be defined together",
    "a_demonter_puis_remonter": "To disassemble then reassemble",
    "a_determiner_avec_lartisan": "To be determined with the craftsman",
    "a_persiennes": "Louvered",
    "a_preciser": "To be specified",
    "age_et_nombre_d_enfants": "Age and number of children:",
    "eclairage": "Lighting",
    "eclairage_decoratif": "Decorative lighting",
    "eclairage_d_ambiance": "Ambient lighting",
    "eclairage_fonctionnel_visage_maquillage": "Functional lighting (face, makeup, etc.)",
    "eclairage_general": "General lighting",
    "eclairage_miroir_integre": "Integrated mirror lighting",
    "elaguer_les_arbres": "Pruning trees",
    "elaguer_un_arbre": "Pruning a tree",
    "electrique": "Electric",
    "electromenager": "Household appliances",
    "eleve": "High",
    "elements_d_installation": "Installation elements",
    "etagere": "Shelf",
    "etagere_avec_rails_reglables": "Shelf with adjustable rails",
    "etagere_verticale": "Vertical shelf",
    "etageres": "Shelves",
    "etageres_bibliotheques": "Shelves / bookcases",
    "etageres_decoratives": "Decorative shelves",
    "etageres_murales": "Wall shelves",
    "etat_moyen": "Average condition",
    "etiquetage": "Labeling",
    "evacuateur": "Evacuator",
    "evacuation_horizontale": "Horizontal discharge",
    "evacuation_verticale": "Vertical discharge",
    "evier": "Sink",
    "evier_bassin": "Sink / Basin",
    "evier_lavabo": "Sink / Washbasin",
    "ilot": "Island",
    "ilot_de_cuisine": "Kitchen island",
    "a_motifs": "patterned",
    "eclairage_eclairage": "lighting",
    "eclairage_et_home_staging": "lighting and home staging",
    "eclairage_home_staging": "home staging lighting",
    "etageres_etageres": "shelves",
    "etagere_etagere": "shelf",
    "etagere_flottante": "floating shelf",
    "etagere_murale_classique": "classic wall shelf",
    "evier_evier": "sink",
    "acces": "Access :",
    "ajoutez_au_moins_un_document_pour_continuer": "Add at least one document to continue.",
    "avec_chauffeur": "With driver:",
    "avez_vous_besoin_dun_service_de_demontage": "Do you need a dismantling service?",
    "avez_vous_besoin_de_planifier_des_travaux_de_soutien": "Do you need to plan support works?",
    "avez_vous_besoin_de_prevoir_des_travaux_de_maconnerie": "Do you need to plan masonry work?",
    "avez_vous_des_exigences_particulieres_concernant_la_couleur_des_joints_facultatif": "Do you have any special requirements regarding the color of the joints? (optional)",
    "avez_vous_deja_des_poteaux_de_portail_facultatif": "Do you already have gate posts? (optional)",
    "besoin_particulier": "Special need:",
    "certaines_zones_doivent_elles_etre_protegees_avant_detre_peintes": "Do certain areas need to be protected before painting?",
    "combien_de_metres_lineaires_pour_votre_cuisine_facultatif": "How many linear meters for your kitchen? (optional)",
    "combien_de_metres_lineaires_sont_concernes_facultatif": "How many linear meters are affected? (Optional)",
    "combien_de_plantes_faut_il_planter_facultatif": "How many plants should you plant? (optional)",
    "combien_de_prises_interrupteurs": "How many sockets/switches?",
    "combien_de_stores_sont_concernes": "How many blinds are affected?",
    "combien_de_volets_sont_concernes": "How many shutters are affected?",
    "comment_souhaitez_vous_controler_le_systeme_facultatif": "How do you want to control the system? (optional)",
    "comment_souhaitez_vous_fixer_vos_plinthes": "How do you want to attach your plinths?",
    "comment_utilisez_vous_votre_chaudiere": "How do you use your boiler?",
    "dans_quelles_pieces_avez_vous_besoin_que_ces_travaux_soient_effectues": "In which rooms do you need this work done?",
    "de_quel_type_de_vmc_double_flux_sagit_il": "What type of double flow VMC is this?",
    "de_quel_type_de_climatiseur_s_agit_il_facultatif": "What type of air conditioner is this? (optional)",
    "de_quel_type_de_materiau_s_apos_agit_il": "What type of material is it?",
    "de_quel_type_de_meubles_sagit_il_veuillez_egalement_preciser_la_quantite_facultatif": "What type of furniture is this? Please also specify the quantity (optional).",
    "de_quel_type_de_mur_sagit_il": "What type of wall is this?",
    "de_quel_type_de_plinthe_sagit_il": "What type of plinth is this?",
    "de_quels_materiaux_sont_faits_vos_stores": "What materials are your blinds made of?",
    "des_modifications_electriques_passage_de_cables_goulottes_murales_sont_elles_necessaires": "Are electrical modifications (cable routing, wall trunking, etc.) necessary?",
    "des_travaux_de_preparation_du_terrain_sont_ils_necessaires_avant_linstallation": "Is site preparation work required before installation?",
    "des_travaux_preparatoires_sont_ils_a_effectuer_avant_linstallation_facultatif": "Is there any preparatory work to be done before installation? (optional)",
    "destination_du_remorquage": "Towing destination:",
    "disposez_vous_doutils_sur_place_pour_la_maintenance": "Do you have tools on site for maintenance?",
    "disposez_vous_doutils_sur_place_pour_la_taille": "Do you have tools on site for pruning?",
    "disposez_vous_doutils_sur_place_pour_tondre_la_pelouse": "Do you have tools on site for mowing the lawn?",
    "distance_entre_le_camion_et_l_apos_entree_approximative": "Distance between truck and entrance (approximate):",
    "faut_il_encore_installer_les_raccordements_au_reseau_d_eau_potable": "Do we still need to install connections to the drinking water network?",
    "faut_il_enlever_lancienne_porte_de_garage": "Should you remove the old garage door?",
    "faut_il_fixer_des_objets_au_mur": "Should we attach objects to the wall?",
    "faut_il_fixer_des_elements_au_mur": "Should items be attached to the wall?",
    "faut_il_installer_une_unite_exterieure": "Should I install an outdoor unit?",
    "faut_il_prevoir_un_conduit_d_evacuation_pour_la_hotte_facultatif": "Is it necessary to provide an exhaust duct for the hood? (optional)",
    "fonctionnalites": "Features:",
    "hauteur_approximative_des_arbres_a_planter": "Approximate height of trees to plant",
    "lalimentation_electrique_est_elle_deja_en_place": "Is the power supply already in place?",
    "lapprovisionnement_en_eau_est_il_deja_en_place": "Is the water supply already in place?",
    "linstallation_est_elle_prete": "Is the installation ready?",
    "lelectricite_est_elle_deja_disponible_a_proximite": "Is electricity already available nearby?",
    "la_piece_est_elle_completement_vide_de_meubles": "Is the room completely empty of furniture?",
    "la_terrasse_sera_installee_le_optionnel": "The terrace will be installed on (optional)",
    "le_revetement_mural_doit_il_etre_retire": "Should the wall covering be removed?",
    "le_sol_a_t_il_besoin_de_terre_vegetale_ou_dautres_amendements": "Does the soil need topsoil or other amendments?",
    "lieu": "Place :",
    "lieu_de_prise_en_charge": "Pick-up location:",
    "lieu_principal": "Main location:",
    "l_alimentation_en_electricite_et_en_eau_est_elle_deja_disponible_facultatif": "Is electricity and water supply already available? (optional)",
    "materiau_de_la_porte": "Door material:",
    "materiau_du_meuble": "Furniture material:",
    "nature_du_probleme_si_reparation": "Nature of the problem (if repair):",
    "nature_du_probleme": "Nature of the problem:",
    "niveau_d_apos_autonomie_ou_besoins": "Level of autonomy or needs:",
    "niveau_d_apos_intervention": "Level of intervention:",
    "niveau_d_accompagnement_souhaite": "Desired level of support:",
    "nombre_d_apos_articles": "Number of items:",
    "nombre_darbres_concernes": "Number of trees affected?",
    "nombre_de_cameras": "Number of cameras:",
    "nombre_de_meubles_a_demonter_monter": "Number of pieces of furniture to dismantle/assemble:",
    "nombre_de_roues": "Number of wheels:",
    "objectif_principal": "Main objective:",
    "ou_se_situe_le_systeme": "Where is the system located?",
    "ou_se_trouvent_les_toilettes": "Where is the bathroom ?",
    "piece_concernee": "Part concerned:",
    "prestation_principale": "Main service:",
    "prestations_complementaires": "Additional services:",
    "probleme": "Issue :",
    "probleme_principal": "Main problem:",
    "probleme_rencontre": "Problem encountered:",
    "produits_amp_exigences": "Products &amp; requirements:",
    "precisez_le_type_de_hotte": "Specify the type of hood",
    "precisez_les_armoires_a_installer_et_leur_quantite": "Specify the cabinets to be installed and their quantity.",
    "precisions_sur_le_chargement_dechargement": "Details on loading/unloading",
    "preferez_vous_une_installation_qui_soit": "Do you prefer an installation that is:",
    "quel_est_letat_de_la_surface_a_peindre_facultatif": "What is the condition of the surface to be painted? (optional)",
    "quel_est_letat_du_sol_mur": "What is the condition of the floor/wall?",
    "quel_est_le_format_de_votre_revetement_de_sol_facultatif": "What is the format of your floor covering? (optional)",
    "quel_est_le_type_devacuation_actuel_facultatif": "What is the current type of evacuation (optional)?",
    "quel_systeme_souhaitez_vous_facultatif": "What system do you want? (optional)",
    "quel_type_dalarme_souhaitez_vous_installer": "What type of alarm do you want to install?",
    "quel_type_dinstallation_souhaitez_vous": "What type of installation do you want?",
    "quel_type_de_fenetre_souhaitez_vous": "What type of window do you want?",
    "quel_type_de_feuilles_concerne_votre_demande": "What type of sheets concerns your request?",
    "quel_type_de_finition_souhaitez_vous_facultatif": "What type of finish do you want? (optional)",
    "quel_type_de_materiaux_pour_vos_volets": "What type of materials for your shutters?",
    "quel_type_de_materiaux_pour_votre_portail": "What type of materials for your gate?",
    "quel_type_de_materiaux_pour_votre_portail_facultatif": "What type of materials for your gate? (optional)",
    "quel_type_de_materiaux_pour_votre_porte": "What type of materials for your door?",
    "quel_type_de_mur": "What type of wall?",
    "quel_type_de_mur_avez_vous": "What type of wall do you have?",
    "quel_type_de_portail_souhaitez_vous": "What type of gate do you want?",
    "quel_type_de_peripherique_souhaitez_vous_installer": "What type of device do you want to install?",
    "quel_type_de_revetement_de_sol_souhaitez_vous_installer": "What type of flooring do you want to install?",
    "quel_type_de_systeme_de_verrouillage_souhaitez_vous_facultatif": "What type of locking system do you want? (optional)",
    "quel_type_de_volets_avez_vous": "What type of shutters do you have?",
    "quel_type_d_energie_utilise_votre_chaudiere": "What type of energy does your boiler use?",
    "quel_s_materiau_x_preferez_vous_pour_la_fabrication": "What material(s) do you prefer for manufacturing?",
    "quelle_est_la_capacite_en_litres_du_chauffe_eau_facultatif": "What is the capacity (in liters) of the water heater? (optional)",
    "quelle_est_la_configuration_de_votre_cuisine_facultatif": "What is the configuration of your kitchen? (optional)",
    "quelle_est_la_hauteur_approximative_des_arbres_a_planter": "What is the approximate height of the trees to be planted?",
    "quelle_est_la_hauteur_des_arbres": "How tall are the trees?",
    "quelle_est_la_hauteur_du_mur_ou_de_la_surface_concernee_facultatif": "What is the height of the wall or surface in question? (optional)",
    "quelle_est_la_longueur_du_mur_ou_de_la_surface_concernee_facultatif": "What is the length of the wall or surface in question? (optional)",
    "quelle_est_la_nature_du_mur_facultatif": "What is the nature of the wall? (optional)",
    "quelle_est_la_surface_concernee_en_m_facultatif": "What is the surface area concerned in m²? (optional)",
    "quelle_est_la_surface_du_plafond_a_enduire_en_m_facultatif": "What is the surface area of ​​the ceiling to be coated, in m²? (optional)",
    "quelle_est_la_surface_murale_a_enduire_en_m_facultatif": "What is the wall surface area to be coated, in m²? (optional)",
    "quelles_pieces_sont_concernees": "Which parts are affected?",
    "quels_types_delements_doivent_etre_installes_precisez_la_quantite": "What types of elements should be installed? Specify the quantity.",
    "quels_elements_de_salle_de_bains_doivent_etre_demontes": "Which bathroom items need to be dismantled?",
    "sagit_il_des_murs_sur_lesquels_les_plinthes_seront_installees": "Are these the walls on which the baseboards will be installed?",
    "serrure": "Lock :",
    "services_additionnels": "Additional services:",
    "services_souhaites": "Desired services:",
    "services_voulus": "Services required:",
    "souhaiteriez_vous_que_les_plinthes_soient": "Would you like the skirting boards to be",
    "souhaitez_vous_installer_un_appareil_electromenager": "Do you want to install a household appliance?",
    "souhaitez_vous_installer_un_thermostat": "Do you want to install a thermostat?",
    "souhaitez_vous_que_lherbe_coupee_soit_enlevee": "Would you like the cut grass removed?",
    "souhaitez_vous_une_sous_couche_facultatif": "Would you like an undercoat? (optional)",
    "style_souhaite": "Desired style:",
    "superficie_approximative": "Approximate area:",
    "sur_quel_type_de_mur_les_meubles_seront_ils_fixes": "What type of wall will the furniture be mounted on?",
    "symptome": "Symptom:",
    "selectionnez_le_type_de_dispositif_concerne_precisez_le_nombre_d_apos_unites": "Select the type of device concerned, specify the number of units?",
    "selectionnez_le_type_de_porte_a_installer_et_indiquez_la_quantite": "Select the type of door to be installed and indicate the quantity.",
    "selectionnez_les_elements_a_installer_et_specifiez_la_quantite": "Select the items to install and specify the quantity?",
    "type_d_apos_acces": "Type of access:",
    "type_de_biens_principaux": "Type of main assets:",
    "type_de_biens_principaux_a_transporter_selection_multiple_possible": "Type of main goods to be transported: (multiple selection possible)",
    "type_de_lieu": "Type of location:",
    "type_de_meuble": "Type of furniture:",
    "type_de_meubles_rangements": "Type of furniture/storage:",
    "type_de_meubles": "Type of furniture:",
    "type_de_panne": "Type of failure:",
    "type_de_porte_serrure": "Door/lock type:",
    "type_de_porte": "Door type:",
    "type_de_prestation": "Type of service:",
    "type_de_rangement": "Type of storage:",
    "type_de_robinet_de_cuisine": "Kitchen faucet type:",
    "type_de_store_precisez_la_quantite": "Type of blind, specify quantity",
    "type_de_traitement_souhaite": "Type of treatment desired:",
    "type_d_intervention": "Type of intervention:",
    "type_d_eclairage": "Type of lighting:",
    "type_d_eclairage_souhaite": "Type of lighting desired:",
    "type_d_elements_a_installer": "Type of elements to install:",
    "type_principal": "Main type:",
    "un_entretien_regulier_est_il_necessaire": "Is regular maintenance necessary?",
    "une_installation_electrique_est_elle_necessaire": "Is an electrical installation necessary?",
    "volume_type_de_transport": "Volume / Type of transport:",
    "volume_approximatif": "Approximate volume:",
    "vos_carreaux_sont": "Your tiles are:",
    "vos_carreaux_sont_ils_la": "Are your tiles there?",
    "vos_meubles_sont_ils": "Is your furniture:",
    "votre_revetement_mural_est_il": "Is your wall covering",
    "vehicule": "Vehicle :",
    "y_a_t_il_des_acces_difficiles": "Are there any difficult accesses?",
    "y_a_t_il_une_prise_electrique_a_proximite": "Is there an electrical outlet nearby?",
    "zone_a_eclairer": "Area to be illuminated:",
    "_journee": "½ day",
    "equipement_concerne": "Equipment affected:",
    "equipements_concernes": "Equipment concerned:",
  },
  confirmEmail: {
    pageTitle: 'Email confirmation',
    loadingTitle: 'Confirming…',
    loadingBody: 'We are verifying your confirmation link.',
    successTitle: 'Email confirmed!',
    errorTitle: 'Confirmation failed',
    invalidLink: 'Invalid or expired confirmation link.',
    defaultSuccess: 'Your email address has been confirmed successfully.',
    defaultError: 'An error occurred while confirming your email.',
  },
  providerDetails: {
    pageTitle: 'Provider details',
    heading: 'Provider information',
    back: 'Back',
    loading: 'Loading…',
    notFound: 'Provider not found.',
    loadError: 'Unable to load provider information.',
    intro: 'Here is the information provided by this provider.',
    noInfo: 'No information available for this provider.',
    service: 'Service',
    subService: 'Sub-service',
    pricing: 'Pricing',
    zone: 'Service area',
  },
  providerReviews: {
    title: 'Customer reviews',
    subtitle: 'What clients think about this provider.',
    reviewsCount: '{{count}} review',
    reviewsCount_plural: '{{count}} reviews',
    noReviews: 'No reviews yet.',
    loginPrompt: 'Log in to leave a review.',
    login: 'Log in',
    leaveReview: 'Leave a review',
    editReview: 'Edit your review',
    ratingLabel: 'Rating',
    commentLabel: 'Your review',
    commentPlaceholder: 'Share your experience with this provider…',
    ratingRequired: 'Please select a rating.',
    commentRequired: 'Please write a comment.',
    submitting: 'Submitting…',
    publishReview: 'Publish review',
    updateReview: 'Update',
    published: 'Your review has been published.',
    updated: 'Your review has been updated.',
    submitError: 'Unable to submit your review.',
    loadError: 'Unable to load reviews.',
    loading: 'Loading reviews…',
    beFirst: 'Be the first to leave a review!',
    ownProfile: 'You cannot review your own profile.',
    client: 'Client',
    ratingAria: 'Rating of {{rating}} out of 5',
    rateAria: 'Rate {{n}} out of 5',
    pickRating: 'Pick a rating',
  },
  serviceProviders: {
    pageTitle: 'Providers',
    forService: 'Providers for: {{name}}',
    browseDesc: 'Browse available providers for this service.',
    loadingServiceInfo: 'Loading service information…',
    loading: 'Loading providers…',
    loadFailed: 'Unable to load providers.',
    noServiceSelected: 'No service selected.',
    noServiceTitle: 'Service not found',
    noServiceBody: 'We could not find this service. Browse the list of available services.',
    found: '{{count}} provider found',
    found_plural: '{{count}} providers found',
    backToServicesLink: '← Back to services',
    backToServices: 'Back to services',
    mapTitle: 'Provider map',
    mapHint: 'Locate providers near you.',
    contactSectionTitle: 'Contact a provider',
    contactSectionDesc: 'Choose a provider and contact them directly.',
    itsYou: 'This is you',
    yearsExp: '{{years}} years of experience',
    availability: 'Availability',
    zone: 'Area',
    pricing: 'Pricing',
    paymentMethod: 'Payment method',
    portfolio: 'Portfolio',
    portfolioMore: '+{{count}} photos',
    contactProvider: 'Contact provider',
    leaveReview: 'Leave a review',
    loadErrorTitle: 'Something went wrong',
    noneTitle: 'No providers available',
    noneBody: 'No providers are registered for this service in your area yet.',
    reviewsCount: '{{count}} review',
    reviewsCount_plural: '{{count}} reviews',
  },
  servicesPage: {
    pageTitle: 'Our services',
    badge: 'Services',
    title: 'All our services',
    subtitle: 'Find the service you need among our categories.',
    becomeProvider: 'Become a provider',
    publishRequest: 'Post a request',
  },
serviceCatalog: {
    subServicesTitle: 'Sub-services {{name}}',
    noSubServices: 'No sub-services available yet.',
    categories: {
      furniture: {
        name: 'Furniture & Decoration',
        subtitle: 'Assembly and decoration services to organize your spaces and finish your interior with care.',
      },
      kitchen: {
        name: 'Kitchen',
        subtitle: 'Kitchen services to install, adjust and fit your elements with precision and safety.',
      },
      bathroom: {
        name: 'Bathroom',
        subtitle: 'Bathroom design and renovation for a functional, modern space suited to your needs.',
      },
      floorWall: {
        name: 'Floor & Wall',
        subtitle: 'Floor and wall covering work to improve aesthetics, protection and durability in your rooms.',
      },
      plumbing: {
        name: 'Plumbing & Heating',
        subtitle: 'Plumbing and heating services to repair, install and optimize your everyday equipment.',
      },
      electricity: {
        name: 'Electricity',
        subtitle: 'Electrical work to modernize your installations, improve comfort and ensure compliance.',
      },
      carpentry: {
        name: 'Carpentry',
        subtitle: 'Carpentry work to install, repair or build wooden elements with durable, neat finishes.',
      },
      gardening: {
        name: 'Gardening',
        subtitle: 'Green space care and landscaping to keep your garden clean, harmonious and pleasant year-round.',
      },
      cleaning: {
        name: 'Cleaning',
        subtitle: 'Cleaning services tailored to your needs: daily upkeep, refresh and deep cleaning.',
      },
      moving: {
        name: 'Moving',
        subtitle: 'Complete moving services: preparation, transport, handling and furniture setup with peace of mind.',
      },
      security: {
        name: 'Security & Locksmithing',
        subtitle: 'Protection and locksmith solutions to secure your home, prevent break-ins and respond quickly in emergencies.',
      },
      mechanic: {
        name: 'Mechanic',
        subtitle: 'Common mechanical services to maintain your vehicle, improve performance and keep you safe on the road.',
      },
    },
    sub: {
      assemblee: 'Assembly',
      montage_meubles: 'Furniture assembly',
      fixation_murale: 'Wall mounting',
      tringle_rideaux: 'Curtain rod',
      traitement_meubles: 'Furniture treatment',
      reparation_meubles: 'Furniture repair',
      decoration_murale: 'Wall decoration and accessories',
      decoration_espaces: 'Space decoration and layout',
      entretien_meubles: 'Furniture care and treatment',
      eclairage_staging: 'Lighting and home staging',
      conseil_decoration: 'Decoration consulting',
      meubles_sur_mesure: 'Custom furniture',
      meubles_cuisine: 'Kitchen cabinets',
      appareils_menagers: 'Home appliances',
      hotte_cuisine: 'Kitchen hood',
      plomberie: 'Plumbing',
      robinetterie: 'Faucets and fixtures',
      espace_rangement: 'Storage space',
      salle_de_bain: 'Bathroom',
      chauffe_eau: 'Water heater',
      mastic: 'Sealant',
      toilettes: 'Toilets',
      meubles_rangement: 'Bathroom furniture and storage',
      cabine_douche: 'Shower cabin',
      eclairage: 'Lighting',
      carrelage: 'Tiling',
      peinture: 'Painting',
      papier_peint: 'Wallpaper',
      parquet: 'Hardwood flooring',
      platrage: 'Plastering',
      plaques_platre: 'Drywall panels',
      dalles_exterieures: 'Outdoor paving',
      plinthes: 'Baseboards',
      terrasse: 'Deck / terrace',
      tapis: 'Carpet',
      beton_poli: 'Polished concrete',
      revetement_sol: 'Floor covering',
      maconnerie: 'Masonry',
      climatisation: 'Air conditioning',
      chauffage: 'Heating',
      chaudiere: 'Boiler',
      tuyaux: 'Pipes',
      entretien_depannage: 'Maintenance and repairs',
      prises_interrupteurs: 'Outlets / switches',
      alarme_camera: 'Alarm / camera',
      interphone: 'Intercom',
      domotique: 'Home automation',
      portail_motorise: 'Motorized gate',
      bornes_tableaux: 'EV chargers / electrical panels',
      volet_motorise: 'Motorized shutter',
      garage_motorise: 'Motorized garage door',
      store_motorise: 'Motorized awning',
      vmc: 'Mechanical ventilation (VMC)',
      reparation_menuiserie: 'Carpentry repair',
      stores: 'Blinds and shutters',
      portail: 'Gate',
      porte: 'Door',
      fenetres: 'Windows / French windows',
      vestiaire: 'Wardrobe / closet',
      cuisine: 'Kitchen',
      obturateur: 'Storm shutter',
      porte_garage: 'Garage door',
      espaces_verts: 'Green spaces',
      tondre: 'Lawn mowing',
      haies: 'Hedges',
      abattage_arbres: 'Tree felling',
      pelouse: 'Lawn care',
      planter_arbre: 'Tree planting',
      clairiere: 'Clearing',
      arbustes: 'Shrubs',
      feuilles: 'Leaf removal',
      fleurs: 'Flowers',
      potager: 'Vegetable garden',
      menage_surface: 'Surface and furniture cleaning',
      repassage: 'Ironing',
      nettoyage_vitres: 'Window cleaning',
      nettoyage_tapis: 'Carpet and sofa cleaning',
      debarass: 'Junk removal',
      organisation_rangement: 'Organization and storage',
      chargement_dechargement: 'Loading and unloading',
      montage_demontage: 'Furniture assembly / disassembly',
      accompagnement_personnes_agees: 'Elderly assistance',
      stockage_meubles: 'Furniture storage',
      garde_enfants: 'Childcare and accompaniment',
      location_utilitaire: 'Van rental with driver',
      ouverture_porte: 'Door opening',
      portes_securisees: 'Security doors',
      serrurerie: 'Locksmithing',
      alarmes: 'Alarms',
      cameras: 'Cameras',
      entretien_reparation: 'Maintenance and repair',
      changement_roues: 'Wheel change',
      batterie_electrique: 'Battery (electric vehicle)',
      plaquettes_frein: 'Brake pad replacement',
      depannage_remorquage: 'Breakdown and towing',
      changement_pieces: 'Auto parts replacement',
      diagnostique_nettoyage: 'Diagnostics and cleaning',
    },
    main: {
      meuble_decoration: 'Furniture & Decoration',
      mobilier_decoration: 'Furniture & Decoration',
      cuisine: 'Kitchen',
      salle_de_bain: 'Bathroom',
      sol_mur: 'Floor & Wall',
      electricite: 'Electricity',
      plomberie_chauffage: 'Plumbing & Heating',
      menuiserie: 'Carpentry',
      jardinage: 'Gardening',
      mecancien: 'Mechanic',
      demenagement: 'Moving',
      menage_nettoyage: 'Cleaning',
      securite_serrurerie: 'Security & Locksmithing',
    },
    details: {
      ourServices: 'Our {{service}} services',
      welcome1: 'Welcome to our page dedicated to {{service}}. Whether you need installation, repair or a full renovation, we offer services tailored to your needs.',
      welcome2: 'We provide a team of experts to ensure a reliable, long-lasting result that meets your expectations.',
      transparentPricing: 'Transparent pricing',
      transparentPricingDesc: 'Easily compare offers and choose the provider that suits you.',
      verifiedProviders: 'Verified providers',
      verifiedProvidersDesc: 'A selection of qualified professionals with genuine customer reviews.',
      satisfiedOrRedone: 'Satisfied or redone',
      satisfiedOrRedoneDesc: 'Quality is monitored to give you more confidence on every job.',
      insuranceIncluded: 'Insurance included',
      insuranceIncludedDesc: 'Services delivered with a high level of safety and accountability.',
      expertsTitle: 'Professionals handling your {{service}} needs',
      expert1: 'Versatile craftsman: fast, careful work for your {{service}} needs.',
      expert2: 'Installation and fitting: work done to standards with clean finishes.',
      expert3: 'Repair and maintenance: diagnosis, restoration and follow-up.',
      expert4: 'Full renovation: support from start to final delivery.',
      expert5: 'Technical advice: material choices suited to your budget.',
      expert6: 'Controlled quality: rated services and verified customer satisfaction.',
      processTitle: 'Bring all your custom projects to life',
      step1Title: 'Post your request',
      step1Text: 'Select a service and quickly describe your needs.',
      step2Title: 'Receive quotes',
      step2Text: 'Skilled local craftsmen provide quotes.',
      step3Title: 'Pay for your request',
      step3Text: 'Choose your payment method to book a craftsman.',
      step4Title: 'Rate your craftsman',
      step4Text: 'Schedule an appointment and rate the work completed.',
      reviewExcellent: 'Excellent',
      reviewExcellentText: 'Based on 14,496 verified reviews.',
      reviewVerified1: 'Verified',
      reviewVerified1Text: 'Great service quality and fast response.',
      reviewVerified2: 'Verified',
      reviewVerified2Text: 'Clear service, reliable craftsman, neat result.',
      reviewVerified3: 'Verified',
      reviewVerified3Text: 'Very good experience, I recommend without hesitation.',
      reasonsTitle: 'Three reasons to choose an Allo Alla provider',
      reason1Title: 'Verified insurance',
      reason1Text: 'Our qualified providers must hold ten-year liability or professional indemnity insurance. Our team verifies this document to ensure your contract is compliant.',
      reason2Title: 'Customer reviews',
      reason2Text: 'After each project, customers leave reviews on craftsmen profiles. You can read past reviews to feel confident and guide your choice.',
      reason3Title: 'Get the best price',
      reason3Text: 'When you submit a request on our site, you receive several quotes from craftsmen based on your budget. This lets you compare prices and get the best rate.',
      otherServicesTitle: 'Other services',
      otherFurniture: 'Furniture and decoration',
      otherKitchen: 'Kitchen',
      otherElectricity: 'Electricity',
      otherBathroom: 'Bathroom',
    },
  }
};

export default en;
export const catalogEn = en.serviceCatalog;
